{
  "79019": {
    "statusCode": 0,
    "data": {
      "cacheExpiryTime": 320,
      "pages": 2,
      "pageIndex": 0,
      "nextPageFetch": 0,
      "cards": [
        {
          "cardType": "couponApplyWidget",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "couponApplyWidget",
            "data": {
              "textPlaceHolder": "Enter Coupon Code",
              "buttonText": "Apply"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "AVAILABLE COUPONS"
            },
            "subtype": "couponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "UNAVAILABLE COUPONS"
            },
            "subtype": "unavailableCouponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT80",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.80 off",
              "description": "Use code FLAT80 & get flat ₹80 off on orders above ₹249.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to get a Flat ₹80 off"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT150",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs. 150 off",
              "description": "Use code FLAT150 & get flat ₹150 off orders above ₹599.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CELEBRATIONS",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.200 off",
              "description": "Use code CELEBRATION & get ₹200 off on orders above ₹799",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹630 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "SWIGGYIT",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get 60% off",
              "description": "Use code SWIGGYIT & get 60% off on orders above ₹179. Maximum discount: ₹110.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hr on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹10 more to get a discount upto ₹110"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MASTERCARDNEW50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/8/2ebec6c7-0843-4daf-8f21-931da1f17888_4.png",
              "title": "Get FLAT ₹50 cashback by tokenizing your Mastercard",
              "description": "Secure & pay using your Mastercard to get ₹50 cashback into your Swiggy Money wallet on transactions above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the campaign",
                  "Valid only on a minimum transaction value of ₹399",
                  "Cashback will only be processed to the users who have tokenized their Mastercard debit or credit card during the payment",
                  "Cashback will be credited to your Swiggy Money wallet in 15 days from the transaction date",
                  "Other T&Cs may apply",
                  "Offer valid till Apr 30, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 105 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXISREWARDS",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1de7c3ce-0a38-4705-885c-ecd31377f4a8_AxisLogo400X4003.png",
              "title": "Get flat ₹150 OFF using Axis Bank Rewards Credit Cards",
              "description": "Flat ₹150 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Rewards Credit Cards (including all recently migrated ones)",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/9e11b331-7649-44de-a484-eb54bc4df00b_AxisLogo400X4003.png",
              "title": "Get flat ₹200 OFF using Axis Bank Select Credit Cards",
              "description": "Flat ₹200 OFF on orders above ₹1000",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Select Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹831 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS120",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1567725f-af88-42a4-8a7d-2db532b73f04_AxisLogo400X4003.png",
              "title": "Get Flat ₹120 OFF using Axis Bank MY ZONE Credit Cards",
              "description": "Flat ₹120 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank MY ZONE Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "HSBC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/a95eb3f5-251c-406b-80c8-da15ddb0d116_HSBCHexagon400x4001.png",
              "title": "Get 10% discount using select HSBC Credit Cards",
              "description": "Flat 10% discount up to ₹100 using select HSBC Credit Cards on orders above ₹999",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable from Wednesday to Sunday",
                  "Valid once per user during the offer period",
                  "Offer valid only on select HSBC Credit Cards",
                  "Not valid on HSBC Live+/ Cashback Credit Card variant starting with 431104",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹830 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "APAYFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/415f4674-6231-4e40-9378-1fbacb4f20cb_AmazonPayNewLogoJun23.png",
              "title": "Get up to ₹100 cashback using Amazon Pay Balance",
              "description": "Up to ₹100 cashback on Amazon Pay Balance transactions above ₹199",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the offer period",
                  "Valid on the net transaction amount of ₹199 & above using Amazon Pay Balance",
                  "Minimum assured cashback of ₹20 will be available in the form of a scratch card in your Amazon Pay account",
                  "Users are eligible for an assured cashback only once across Food & Instamart",
                  "Valid only for users who have linked their Amazon account and paid using Amazon Pay Balance",
                  "Not valid on payments via Amazon Pay UPI directly from the UPI section or Amazon Pay balance",
                  "The cashback will only be issued once the customer scratches the issued card by going to the Rewards page on Amazon Pay",
                  "Once the scratched card is scratched, cashback will be credited as Amazon Pay Balance within 24 hours",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹30 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISABOBDC",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f387cda5-008f-49c3-b443-6e7cc4873744_VisaBankofBarodaLogo.png",
              "title": "Get 20% discount using Bank of Baroda Visa Debit Cards",
              "description": "Maximum ₹130 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on Bank of Baroda Visa Debit Cards",
                  "Valid only on Monday, Tuesday, Wednesday & Thursday",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "INDUSINDDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/5721e0f9-0d11-4214-b70f-20a8b52e1ae5_IndusIndBankLogoBurgundyTwoLine02.png",
              "title": "Save ₹200 OFF using select IndusInd Bank Debit Cards",
              "description": "Maximum up to ₹200 OFF using IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards on orders above ₹600",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards variants",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹431 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS150",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/4cce62d6-9414-45f4-9d8e-82d689594b8a_AxisLogo400X4003.png",
              "title": "Get 25% OFF using Axis Bank Delight Debit Cards",
              "description": "Maximum up to ₹150 OFF on orders above ₹400",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable thrice per user per calendar month",
                  "Valid only on Axis Bank Delight Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹231 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MBKFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/31d31f7d-e9e2-40ea-b7c2-0f3cece34e78_MobiKwikFoodOffersLogoLatest2.png",
              "title": "Get up to ₹150 cashback using MobiKwik wallet",
              "description": "Assured ₹15 to ₹150 Instant Cashback via Scratch Card on MobiKwik wallet transactions above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per month",
                  "Assured cashback will be ₹15 per transaction",
                  "Valid on the net transaction amount of ₹249 & above using the MobiKwik wallet",
                  "Cashback can be claimed through a Scratch card on the MobiKwik app in the rewards section & the Scratch card will be valid for 7 days only",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/5/9d446beb-b2ce-480f-8b70-58b8e8038001_AUBank400X400Logo.png",
              "title": "Get 20% discount using AU Debit Cards",
              "description": "Maximum up to ₹111 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid only on AU Debit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "PNBCC125",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/e948424c-1683-492c-ad40-dab329505568_PNBFoodOffersLogo.png",
              "title": "Get 15% discount using Punjab National Bank Credit Cards",
              "description": "Maximum discount of ₹125 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Punjab National Bank Credit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZAGGCARD",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/18/361c4086-1746-439a-bd0a-75acbae97c28_ZaggCoinLogo.png",
              "title": "Get 40% discount using Zagg Credit Card",
              "description": "Maximum up to ₹100 OFF on orders above ₹200",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Zagg Credit Cards issued under BIN 356191906",
                  "Applicable once per user during the offer period",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹31 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUCC50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/d8ce833e-602e-4be8-bb61-c51f8dc115cf_AUBank400X400Logo.png",
              "title": "Get 5% discount using AU Credit Cards",
              "description": "Maximum discount of ₹50 on orders above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per month",
                  "Valid only on AU Credit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBICC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f294f5a3-a376-4f5b-87b5-58e9dbc4dbf3_IDBI400X4004.png",
              "title": "Get 15% discount using IDBI Bank Credit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IDBI Bank Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBIDC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ba5c2bab-955a-4ff6-8345-6ec6d96d6631_IDBI400X4004.png",
              "title": "Get 15% discount using select IDBI Bank Debit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on IDBI Bank Platinum & Signature variant Debit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZETCARD100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/b47eb00e-6232-40ab-8c68-24486989a87c_ZET400x400Logo.png",
              "title": "Get Flat ₹100 OFF using ZET Credit Card",
              "description": "Get ZET Credit Card on the Zet App to unlock this Offer, Flat ₹100 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on all ZET cards issued by SBM Bank, IOB, and DCB Bank",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARACC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/abe79014-b8e3-48fc-b05e-e05162ceddd9_CanaraBankVisaNewLogo.png",
              "title": "Get 15% discount using Canara Bank Visa Credit Cards",
              "description": "Maximum discount up to ₹100 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CBIDC75",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/14/4bd1e216-0f03-4326-bda0-fa7e8cb14713_CentralBankOfIndiaFoodOffersLogo.png",
              "title": "Get flat ₹75 discount using Central Bank of India Debit Cards",
              "description": "Flat ₹75 OFF on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid on all Central Bank of India Debit Cards",
                  "Applicable once per user per week",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 21, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 6 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARADC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/8e46ed72-e428-40f1-98e6-032505f8a22f_CanaraBankVisaNewLogo.png",
              "title": "Flat ₹100 OFF",
              "description": "Use Canara Bank Visa Debit Cards to get Flat ₹100 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "NOVIO100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ff4ecf82-7ac5-4b3a-870a-f4464f90a07e_NovioFoodOffersLogo.png",
              "title": "Get flat ₹100 discount using SBM Credilio Credit Card",
              "description": "FLAT ₹100 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Get your guaranteed SBM Credilio Credit Card on the Novio App",
                  "Applicable once per user during the offer period",
                  "Exclusive to SBM Credilio Credit Card holders",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        }
      ]
    },
    "tid": "88cc8a44-ea1a-4fb8-9a9f-20e77fc757a1",
    "sid": "p4p56099-037e-40d8-a215-e0604df50d69",
    "deviceId": "663cd9c7-0449-024f-940c-b517fba567ac",
    "csrfToken": "8DOrGbOarj1z-oDV6R5sITDIVGhRj5wU1qmaobqE"
  },

  "794529": {
    "statusCode": 0,
    "data": {
      "cacheExpiryTime": 320,
      "pages": 2,
      "pageIndex": 0,
      "nextPageFetch": 0,
      "cards": [
        {
          "cardType": "couponApplyWidget",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "couponApplyWidget",
            "data": {
              "textPlaceHolder": "Enter Coupon Code",
              "buttonText": "Apply"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "AVAILABLE COUPONS"
            },
            "subtype": "couponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "UNAVAILABLE COUPONS"
            },
            "subtype": "unavailableCouponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT80",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.80 off",
              "description": "Use code FLAT80 & get flat ₹80 off on orders above ₹249.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to get a Flat ₹80 off"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT150",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs. 150 off",
              "description": "Use code FLAT150 & get flat ₹150 off orders above ₹599.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CELEBRATIONS",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.200 off",
              "description": "Use code CELEBRATION & get ₹200 off on orders above ₹799",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹630 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "SWIGGYIT",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get 60% off",
              "description": "Use code SWIGGYIT & get 60% off on orders above ₹179. Maximum discount: ₹110.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hr on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹10 more to get a discount upto ₹110"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MASTERCARDNEW50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/8/2ebec6c7-0843-4daf-8f21-931da1f17888_4.png",
              "title": "Get FLAT ₹50 cashback by tokenizing your Mastercard",
              "description": "Secure & pay using your Mastercard to get ₹50 cashback into your Swiggy Money wallet on transactions above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the campaign",
                  "Valid only on a minimum transaction value of ₹399",
                  "Cashback will only be processed to the users who have tokenized their Mastercard debit or credit card during the payment",
                  "Cashback will be credited to your Swiggy Money wallet in 15 days from the transaction date",
                  "Other T&Cs may apply",
                  "Offer valid till Apr 30, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 105 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXISREWARDS",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1de7c3ce-0a38-4705-885c-ecd31377f4a8_AxisLogo400X4003.png",
              "title": "Get flat ₹150 OFF using Axis Bank Rewards Credit Cards",
              "description": "Flat ₹150 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Rewards Credit Cards (including all recently migrated ones)",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/9e11b331-7649-44de-a484-eb54bc4df00b_AxisLogo400X4003.png",
              "title": "Get flat ₹200 OFF using Axis Bank Select Credit Cards",
              "description": "Flat ₹200 OFF on orders above ₹1000",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Select Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹831 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS120",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1567725f-af88-42a4-8a7d-2db532b73f04_AxisLogo400X4003.png",
              "title": "Get Flat ₹120 OFF using Axis Bank MY ZONE Credit Cards",
              "description": "Flat ₹120 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank MY ZONE Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "HSBC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/a95eb3f5-251c-406b-80c8-da15ddb0d116_HSBCHexagon400x4001.png",
              "title": "Get 10% discount using select HSBC Credit Cards",
              "description": "Flat 10% discount up to ₹100 using select HSBC Credit Cards on orders above ₹999",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable from Wednesday to Sunday",
                  "Valid once per user during the offer period",
                  "Offer valid only on select HSBC Credit Cards",
                  "Not valid on HSBC Live+/ Cashback Credit Card variant starting with 431104",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹830 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "APAYFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/415f4674-6231-4e40-9378-1fbacb4f20cb_AmazonPayNewLogoJun23.png",
              "title": "Get up to ₹100 cashback using Amazon Pay Balance",
              "description": "Up to ₹100 cashback on Amazon Pay Balance transactions above ₹199",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the offer period",
                  "Valid on the net transaction amount of ₹199 & above using Amazon Pay Balance",
                  "Minimum assured cashback of ₹20 will be available in the form of a scratch card in your Amazon Pay account",
                  "Users are eligible for an assured cashback only once across Food & Instamart",
                  "Valid only for users who have linked their Amazon account and paid using Amazon Pay Balance",
                  "Not valid on payments via Amazon Pay UPI directly from the UPI section or Amazon Pay balance",
                  "The cashback will only be issued once the customer scratches the issued card by going to the Rewards page on Amazon Pay",
                  "Once the scratched card is scratched, cashback will be credited as Amazon Pay Balance within 24 hours",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹30 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISABOBDC",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f387cda5-008f-49c3-b443-6e7cc4873744_VisaBankofBarodaLogo.png",
              "title": "Get 20% discount using Bank of Baroda Visa Debit Cards",
              "description": "Maximum ₹130 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on Bank of Baroda Visa Debit Cards",
                  "Valid only on Monday, Tuesday, Wednesday & Thursday",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "INDUSINDDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/5721e0f9-0d11-4214-b70f-20a8b52e1ae5_IndusIndBankLogoBurgundyTwoLine02.png",
              "title": "Save ₹200 OFF using select IndusInd Bank Debit Cards",
              "description": "Maximum up to ₹200 OFF using IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards on orders above ₹600",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards variants",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹431 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS150",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/4cce62d6-9414-45f4-9d8e-82d689594b8a_AxisLogo400X4003.png",
              "title": "Get 25% OFF using Axis Bank Delight Debit Cards",
              "description": "Maximum up to ₹150 OFF on orders above ₹400",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable thrice per user per calendar month",
                  "Valid only on Axis Bank Delight Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹231 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MBKFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/31d31f7d-e9e2-40ea-b7c2-0f3cece34e78_MobiKwikFoodOffersLogoLatest2.png",
              "title": "Get up to ₹150 cashback using MobiKwik wallet",
              "description": "Assured ₹15 to ₹150 Instant Cashback via Scratch Card on MobiKwik wallet transactions above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per month",
                  "Assured cashback will be ₹15 per transaction",
                  "Valid on the net transaction amount of ₹249 & above using the MobiKwik wallet",
                  "Cashback can be claimed through a Scratch card on the MobiKwik app in the rewards section & the Scratch card will be valid for 7 days only",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/5/9d446beb-b2ce-480f-8b70-58b8e8038001_AUBank400X400Logo.png",
              "title": "Get 20% discount using AU Debit Cards",
              "description": "Maximum up to ₹111 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid only on AU Debit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "PNBCC125",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/e948424c-1683-492c-ad40-dab329505568_PNBFoodOffersLogo.png",
              "title": "Get 15% discount using Punjab National Bank Credit Cards",
              "description": "Maximum discount of ₹125 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Punjab National Bank Credit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZAGGCARD",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/18/361c4086-1746-439a-bd0a-75acbae97c28_ZaggCoinLogo.png",
              "title": "Get 40% discount using Zagg Credit Card",
              "description": "Maximum up to ₹100 OFF on orders above ₹200",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Zagg Credit Cards issued under BIN 356191906",
                  "Applicable once per user during the offer period",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹31 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUCC50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/d8ce833e-602e-4be8-bb61-c51f8dc115cf_AUBank400X400Logo.png",
              "title": "Get 5% discount using AU Credit Cards",
              "description": "Maximum discount of ₹50 on orders above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per month",
                  "Valid only on AU Credit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBICC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f294f5a3-a376-4f5b-87b5-58e9dbc4dbf3_IDBI400X4004.png",
              "title": "Get 15% discount using IDBI Bank Credit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IDBI Bank Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBIDC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ba5c2bab-955a-4ff6-8345-6ec6d96d6631_IDBI400X4004.png",
              "title": "Get 15% discount using select IDBI Bank Debit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on IDBI Bank Platinum & Signature variant Debit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZETCARD100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/b47eb00e-6232-40ab-8c68-24486989a87c_ZET400x400Logo.png",
              "title": "Get Flat ₹100 OFF using ZET Credit Card",
              "description": "Get ZET Credit Card on the Zet App to unlock this Offer, Flat ₹100 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on all ZET cards issued by SBM Bank, IOB, and DCB Bank",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARACC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/abe79014-b8e3-48fc-b05e-e05162ceddd9_CanaraBankVisaNewLogo.png",
              "title": "Get 15% discount using Canara Bank Visa Credit Cards",
              "description": "Maximum discount up to ₹100 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CBIDC75",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/14/4bd1e216-0f03-4326-bda0-fa7e8cb14713_CentralBankOfIndiaFoodOffersLogo.png",
              "title": "Get flat ₹75 discount using Central Bank of India Debit Cards",
              "description": "Flat ₹75 OFF on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid on all Central Bank of India Debit Cards",
                  "Applicable once per user per week",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 21, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 6 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARADC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/8e46ed72-e428-40f1-98e6-032505f8a22f_CanaraBankVisaNewLogo.png",
              "title": "Flat ₹100 OFF",
              "description": "Use Canara Bank Visa Debit Cards to get Flat ₹100 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "NOVIO100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ff4ecf82-7ac5-4b3a-870a-f4464f90a07e_NovioFoodOffersLogo.png",
              "title": "Get flat ₹100 discount using SBM Credilio Credit Card",
              "description": "FLAT ₹100 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Get your guaranteed SBM Credilio Credit Card on the Novio App",
                  "Applicable once per user during the offer period",
                  "Exclusive to SBM Credilio Credit Card holders",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        }
      ]
    },
    "tid": "88cc8a44-ea1a-4fb8-9a9f-20e77fc757a1",
    "sid": "p4p56099-037e-40d8-a215-e0604df50d69",
    "deviceId": "663cd9c7-0449-024f-940c-b517fba567ac",
    "csrfToken": "MKPMelm2SZfg-Xt5AoaT-MrgIp0R1Le0oS0tE0Sw"
  },

  "425509": {
    "statusCode": 0,
    "data": {
      "cacheExpiryTime": 320,
      "pages": 2,
      "pageIndex": 0,
      "nextPageFetch": 0,
      "cards": [
        {
          "cardType": "couponApplyWidget",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "couponApplyWidget",
            "data": {
              "textPlaceHolder": "Enter Coupon Code",
              "buttonText": "Apply"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "AVAILABLE COUPONS"
            },
            "subtype": "couponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "UNAVAILABLE COUPONS"
            },
            "subtype": "unavailableCouponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT80",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.80 off",
              "description": "Use code FLAT80 & get flat ₹80 off on orders above ₹249.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to get a Flat ₹80 off"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT150",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs. 150 off",
              "description": "Use code FLAT150 & get flat ₹150 off orders above ₹599.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CELEBRATIONS",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.200 off",
              "description": "Use code CELEBRATION & get ₹200 off on orders above ₹799",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹630 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "SWIGGYIT",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get 60% off",
              "description": "Use code SWIGGYIT & get 60% off on orders above ₹179. Maximum discount: ₹110.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hr on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹10 more to get a discount upto ₹110"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MASTERCARDNEW50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/8/2ebec6c7-0843-4daf-8f21-931da1f17888_4.png",
              "title": "Get FLAT ₹50 cashback by tokenizing your Mastercard",
              "description": "Secure & pay using your Mastercard to get ₹50 cashback into your Swiggy Money wallet on transactions above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the campaign",
                  "Valid only on a minimum transaction value of ₹399",
                  "Cashback will only be processed to the users who have tokenized their Mastercard debit or credit card during the payment",
                  "Cashback will be credited to your Swiggy Money wallet in 15 days from the transaction date",
                  "Other T&Cs may apply",
                  "Offer valid till Apr 30, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 105 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXISREWARDS",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1de7c3ce-0a38-4705-885c-ecd31377f4a8_AxisLogo400X4003.png",
              "title": "Get flat ₹150 OFF using Axis Bank Rewards Credit Cards",
              "description": "Flat ₹150 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Rewards Credit Cards (including all recently migrated ones)",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/9e11b331-7649-44de-a484-eb54bc4df00b_AxisLogo400X4003.png",
              "title": "Get flat ₹200 OFF using Axis Bank Select Credit Cards",
              "description": "Flat ₹200 OFF on orders above ₹1000",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Select Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹831 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS120",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1567725f-af88-42a4-8a7d-2db532b73f04_AxisLogo400X4003.png",
              "title": "Get Flat ₹120 OFF using Axis Bank MY ZONE Credit Cards",
              "description": "Flat ₹120 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank MY ZONE Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "HSBC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/a95eb3f5-251c-406b-80c8-da15ddb0d116_HSBCHexagon400x4001.png",
              "title": "Get 10% discount using select HSBC Credit Cards",
              "description": "Flat 10% discount up to ₹100 using select HSBC Credit Cards on orders above ₹999",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable from Wednesday to Sunday",
                  "Valid once per user during the offer period",
                  "Offer valid only on select HSBC Credit Cards",
                  "Not valid on HSBC Live+/ Cashback Credit Card variant starting with 431104",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹830 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "APAYFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/415f4674-6231-4e40-9378-1fbacb4f20cb_AmazonPayNewLogoJun23.png",
              "title": "Get up to ₹100 cashback using Amazon Pay Balance",
              "description": "Up to ₹100 cashback on Amazon Pay Balance transactions above ₹199",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the offer period",
                  "Valid on the net transaction amount of ₹199 & above using Amazon Pay Balance",
                  "Minimum assured cashback of ₹20 will be available in the form of a scratch card in your Amazon Pay account",
                  "Users are eligible for an assured cashback only once across Food & Instamart",
                  "Valid only for users who have linked their Amazon account and paid using Amazon Pay Balance",
                  "Not valid on payments via Amazon Pay UPI directly from the UPI section or Amazon Pay balance",
                  "The cashback will only be issued once the customer scratches the issued card by going to the Rewards page on Amazon Pay",
                  "Once the scratched card is scratched, cashback will be credited as Amazon Pay Balance within 24 hours",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹30 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISABOBDC",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f387cda5-008f-49c3-b443-6e7cc4873744_VisaBankofBarodaLogo.png",
              "title": "Get 20% discount using Bank of Baroda Visa Debit Cards",
              "description": "Maximum ₹130 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on Bank of Baroda Visa Debit Cards",
                  "Valid only on Monday, Tuesday, Wednesday & Thursday",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "INDUSINDDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/5721e0f9-0d11-4214-b70f-20a8b52e1ae5_IndusIndBankLogoBurgundyTwoLine02.png",
              "title": "Save ₹200 OFF using select IndusInd Bank Debit Cards",
              "description": "Maximum up to ₹200 OFF using IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards on orders above ₹600",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards variants",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹431 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS150",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/4cce62d6-9414-45f4-9d8e-82d689594b8a_AxisLogo400X4003.png",
              "title": "Get 25% OFF using Axis Bank Delight Debit Cards",
              "description": "Maximum up to ₹150 OFF on orders above ₹400",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable thrice per user per calendar month",
                  "Valid only on Axis Bank Delight Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹231 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MBKFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/31d31f7d-e9e2-40ea-b7c2-0f3cece34e78_MobiKwikFoodOffersLogoLatest2.png",
              "title": "Get up to ₹150 cashback using MobiKwik wallet",
              "description": "Assured ₹15 to ₹150 Instant Cashback via Scratch Card on MobiKwik wallet transactions above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per month",
                  "Assured cashback will be ₹15 per transaction",
                  "Valid on the net transaction amount of ₹249 & above using the MobiKwik wallet",
                  "Cashback can be claimed through a Scratch card on the MobiKwik app in the rewards section & the Scratch card will be valid for 7 days only",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/5/9d446beb-b2ce-480f-8b70-58b8e8038001_AUBank400X400Logo.png",
              "title": "Get 20% discount using AU Debit Cards",
              "description": "Maximum up to ₹111 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid only on AU Debit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "PNBCC125",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/e948424c-1683-492c-ad40-dab329505568_PNBFoodOffersLogo.png",
              "title": "Get 15% discount using Punjab National Bank Credit Cards",
              "description": "Maximum discount of ₹125 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Punjab National Bank Credit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZAGGCARD",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/18/361c4086-1746-439a-bd0a-75acbae97c28_ZaggCoinLogo.png",
              "title": "Get 40% discount using Zagg Credit Card",
              "description": "Maximum up to ₹100 OFF on orders above ₹200",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Zagg Credit Cards issued under BIN 356191906",
                  "Applicable once per user during the offer period",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹31 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUCC50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/d8ce833e-602e-4be8-bb61-c51f8dc115cf_AUBank400X400Logo.png",
              "title": "Get 5% discount using AU Credit Cards",
              "description": "Maximum discount of ₹50 on orders above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per month",
                  "Valid only on AU Credit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBICC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f294f5a3-a376-4f5b-87b5-58e9dbc4dbf3_IDBI400X4004.png",
              "title": "Get 15% discount using IDBI Bank Credit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IDBI Bank Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBIDC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ba5c2bab-955a-4ff6-8345-6ec6d96d6631_IDBI400X4004.png",
              "title": "Get 15% discount using select IDBI Bank Debit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on IDBI Bank Platinum & Signature variant Debit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZETCARD100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/b47eb00e-6232-40ab-8c68-24486989a87c_ZET400x400Logo.png",
              "title": "Get Flat ₹100 OFF using ZET Credit Card",
              "description": "Get ZET Credit Card on the Zet App to unlock this Offer, Flat ₹100 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on all ZET cards issued by SBM Bank, IOB, and DCB Bank",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARACC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/abe79014-b8e3-48fc-b05e-e05162ceddd9_CanaraBankVisaNewLogo.png",
              "title": "Get 15% discount using Canara Bank Visa Credit Cards",
              "description": "Maximum discount up to ₹100 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CBIDC75",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/14/4bd1e216-0f03-4326-bda0-fa7e8cb14713_CentralBankOfIndiaFoodOffersLogo.png",
              "title": "Get flat ₹75 discount using Central Bank of India Debit Cards",
              "description": "Flat ₹75 OFF on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid on all Central Bank of India Debit Cards",
                  "Applicable once per user per week",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 21, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 6 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARADC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/8e46ed72-e428-40f1-98e6-032505f8a22f_CanaraBankVisaNewLogo.png",
              "title": "Flat ₹100 OFF",
              "description": "Use Canara Bank Visa Debit Cards to get Flat ₹100 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "NOVIO100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ff4ecf82-7ac5-4b3a-870a-f4464f90a07e_NovioFoodOffersLogo.png",
              "title": "Get flat ₹100 discount using SBM Credilio Credit Card",
              "description": "FLAT ₹100 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Get your guaranteed SBM Credilio Credit Card on the Novio App",
                  "Applicable once per user during the offer period",
                  "Exclusive to SBM Credilio Credit Card holders",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        }
      ]
    },
    "tid": "88cc8a44-ea1a-4fb8-9a9f-20e77fc757a1",
    "sid": "p4p56099-037e-40d8-a215-e0604df50d69",
    "deviceId": "663cd9c7-0449-024f-940c-b517fba567ac",
    "csrfToken": "XfhxTyegZ7sk-rFFT2sS9i46RyduVErfHnUKsMaM"
  },

  "79774": {
    "statusCode": 0,
    "data": {
      "cacheExpiryTime": 320,
      "pages": 2,
      "pageIndex": 0,
      "nextPageFetch": 0,
      "cards": [
        {
          "cardType": "couponApplyWidget",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "couponApplyWidget",
            "data": {
              "textPlaceHolder": "Enter Coupon Code",
              "buttonText": "Apply"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "AVAILABLE COUPONS"
            },
            "subtype": "couponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "UNAVAILABLE COUPONS"
            },
            "subtype": "unavailableCouponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT80",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.80 off",
              "description": "Use code FLAT80 & get flat ₹80 off on orders above ₹249.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to get a Flat ₹80 off"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT150",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs. 150 off",
              "description": "Use code FLAT150 & get flat ₹150 off orders above ₹599.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CELEBRATIONS",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.200 off",
              "description": "Use code CELEBRATION & get ₹200 off on orders above ₹799",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹630 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "SWIGGYIT",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get 60% off",
              "description": "Use code SWIGGYIT & get 60% off on orders above ₹179. Maximum discount: ₹110.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hr on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹10 more to get a discount upto ₹110"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MASTERCARDNEW50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/8/2ebec6c7-0843-4daf-8f21-931da1f17888_4.png",
              "title": "Get FLAT ₹50 cashback by tokenizing your Mastercard",
              "description": "Secure & pay using your Mastercard to get ₹50 cashback into your Swiggy Money wallet on transactions above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the campaign",
                  "Valid only on a minimum transaction value of ₹399",
                  "Cashback will only be processed to the users who have tokenized their Mastercard debit or credit card during the payment",
                  "Cashback will be credited to your Swiggy Money wallet in 15 days from the transaction date",
                  "Other T&Cs may apply",
                  "Offer valid till Apr 30, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 105 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXISREWARDS",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1de7c3ce-0a38-4705-885c-ecd31377f4a8_AxisLogo400X4003.png",
              "title": "Get flat ₹150 OFF using Axis Bank Rewards Credit Cards",
              "description": "Flat ₹150 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Rewards Credit Cards (including all recently migrated ones)",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/9e11b331-7649-44de-a484-eb54bc4df00b_AxisLogo400X4003.png",
              "title": "Get flat ₹200 OFF using Axis Bank Select Credit Cards",
              "description": "Flat ₹200 OFF on orders above ₹1000",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Select Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹831 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS120",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1567725f-af88-42a4-8a7d-2db532b73f04_AxisLogo400X4003.png",
              "title": "Get Flat ₹120 OFF using Axis Bank MY ZONE Credit Cards",
              "description": "Flat ₹120 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank MY ZONE Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "HSBC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/a95eb3f5-251c-406b-80c8-da15ddb0d116_HSBCHexagon400x4001.png",
              "title": "Get 10% discount using select HSBC Credit Cards",
              "description": "Flat 10% discount up to ₹100 using select HSBC Credit Cards on orders above ₹999",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable from Wednesday to Sunday",
                  "Valid once per user during the offer period",
                  "Offer valid only on select HSBC Credit Cards",
                  "Not valid on HSBC Live+/ Cashback Credit Card variant starting with 431104",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹830 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "APAYFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/415f4674-6231-4e40-9378-1fbacb4f20cb_AmazonPayNewLogoJun23.png",
              "title": "Get up to ₹100 cashback using Amazon Pay Balance",
              "description": "Up to ₹100 cashback on Amazon Pay Balance transactions above ₹199",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the offer period",
                  "Valid on the net transaction amount of ₹199 & above using Amazon Pay Balance",
                  "Minimum assured cashback of ₹20 will be available in the form of a scratch card in your Amazon Pay account",
                  "Users are eligible for an assured cashback only once across Food & Instamart",
                  "Valid only for users who have linked their Amazon account and paid using Amazon Pay Balance",
                  "Not valid on payments via Amazon Pay UPI directly from the UPI section or Amazon Pay balance",
                  "The cashback will only be issued once the customer scratches the issued card by going to the Rewards page on Amazon Pay",
                  "Once the scratched card is scratched, cashback will be credited as Amazon Pay Balance within 24 hours",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹30 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISABOBDC",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f387cda5-008f-49c3-b443-6e7cc4873744_VisaBankofBarodaLogo.png",
              "title": "Get 20% discount using Bank of Baroda Visa Debit Cards",
              "description": "Maximum ₹130 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on Bank of Baroda Visa Debit Cards",
                  "Valid only on Monday, Tuesday, Wednesday & Thursday",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "INDUSINDDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/5721e0f9-0d11-4214-b70f-20a8b52e1ae5_IndusIndBankLogoBurgundyTwoLine02.png",
              "title": "Save ₹200 OFF using select IndusInd Bank Debit Cards",
              "description": "Maximum up to ₹200 OFF using IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards on orders above ₹600",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards variants",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹431 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS150",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/4cce62d6-9414-45f4-9d8e-82d689594b8a_AxisLogo400X4003.png",
              "title": "Get 25% OFF using Axis Bank Delight Debit Cards",
              "description": "Maximum up to ₹150 OFF on orders above ₹400",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable thrice per user per calendar month",
                  "Valid only on Axis Bank Delight Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹231 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MBKFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/31d31f7d-e9e2-40ea-b7c2-0f3cece34e78_MobiKwikFoodOffersLogoLatest2.png",
              "title": "Get up to ₹150 cashback using MobiKwik wallet",
              "description": "Assured ₹15 to ₹150 Instant Cashback via Scratch Card on MobiKwik wallet transactions above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per month",
                  "Assured cashback will be ₹15 per transaction",
                  "Valid on the net transaction amount of ₹249 & above using the MobiKwik wallet",
                  "Cashback can be claimed through a Scratch card on the MobiKwik app in the rewards section & the Scratch card will be valid for 7 days only",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/5/9d446beb-b2ce-480f-8b70-58b8e8038001_AUBank400X400Logo.png",
              "title": "Get 20% discount using AU Debit Cards",
              "description": "Maximum up to ₹111 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid only on AU Debit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "PNBCC125",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/e948424c-1683-492c-ad40-dab329505568_PNBFoodOffersLogo.png",
              "title": "Get 15% discount using Punjab National Bank Credit Cards",
              "description": "Maximum discount of ₹125 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Punjab National Bank Credit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZAGGCARD",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/18/361c4086-1746-439a-bd0a-75acbae97c28_ZaggCoinLogo.png",
              "title": "Get 40% discount using Zagg Credit Card",
              "description": "Maximum up to ₹100 OFF on orders above ₹200",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Zagg Credit Cards issued under BIN 356191906",
                  "Applicable once per user during the offer period",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹31 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUCC50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/d8ce833e-602e-4be8-bb61-c51f8dc115cf_AUBank400X400Logo.png",
              "title": "Get 5% discount using AU Credit Cards",
              "description": "Maximum discount of ₹50 on orders above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per month",
                  "Valid only on AU Credit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBICC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f294f5a3-a376-4f5b-87b5-58e9dbc4dbf3_IDBI400X4004.png",
              "title": "Get 15% discount using IDBI Bank Credit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IDBI Bank Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBIDC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ba5c2bab-955a-4ff6-8345-6ec6d96d6631_IDBI400X4004.png",
              "title": "Get 15% discount using select IDBI Bank Debit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on IDBI Bank Platinum & Signature variant Debit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZETCARD100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/b47eb00e-6232-40ab-8c68-24486989a87c_ZET400x400Logo.png",
              "title": "Get Flat ₹100 OFF using ZET Credit Card",
              "description": "Get ZET Credit Card on the Zet App to unlock this Offer, Flat ₹100 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on all ZET cards issued by SBM Bank, IOB, and DCB Bank",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARACC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/abe79014-b8e3-48fc-b05e-e05162ceddd9_CanaraBankVisaNewLogo.png",
              "title": "Get 15% discount using Canara Bank Visa Credit Cards",
              "description": "Maximum discount up to ₹100 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CBIDC75",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/14/4bd1e216-0f03-4326-bda0-fa7e8cb14713_CentralBankOfIndiaFoodOffersLogo.png",
              "title": "Get flat ₹75 discount using Central Bank of India Debit Cards",
              "description": "Flat ₹75 OFF on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid on all Central Bank of India Debit Cards",
                  "Applicable once per user per week",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 21, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 6 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARADC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/8e46ed72-e428-40f1-98e6-032505f8a22f_CanaraBankVisaNewLogo.png",
              "title": "Flat ₹100 OFF",
              "description": "Use Canara Bank Visa Debit Cards to get Flat ₹100 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "NOVIO100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ff4ecf82-7ac5-4b3a-870a-f4464f90a07e_NovioFoodOffersLogo.png",
              "title": "Get flat ₹100 discount using SBM Credilio Credit Card",
              "description": "FLAT ₹100 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Get your guaranteed SBM Credilio Credit Card on the Novio App",
                  "Applicable once per user during the offer period",
                  "Exclusive to SBM Credilio Credit Card holders",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        }
      ]
    },
    "tid": "88cc8a44-ea1a-4fb8-9a9f-20e77fc757a1",
    "sid": "p4p56099-037e-40d8-a215-e0604df50d69",
    "deviceId": "663cd9c7-0449-024f-940c-b517fba567ac",
    "csrfToken": "TeAJ0yI9EvM0-I6IrFTy2V7nqFtVULbwU0iW-OvE"
  },
  "697182": {
    "statusCode": 0,
    "data": {
      "cacheExpiryTime": 320,
      "pages": 2,
      "pageIndex": 0,
      "nextPageFetch": 0,
      "cards": [
        {
          "cardType": "couponApplyWidget",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "couponApplyWidget",
            "data": {
              "textPlaceHolder": "Enter Coupon Code",
              "buttonText": "Apply"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "AVAILABLE COUPONS"
            },
            "subtype": "couponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "UNAVAILABLE COUPONS"
            },
            "subtype": "unavailableCouponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT80",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.80 off",
              "description": "Use code FLAT80 & get flat ₹80 off on orders above ₹249.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to get a Flat ₹80 off"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT150",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs. 150 off",
              "description": "Use code FLAT150 & get flat ₹150 off orders above ₹599.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CELEBRATIONS",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.200 off",
              "description": "Use code CELEBRATION & get ₹200 off on orders above ₹799",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹630 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "SWIGGYIT",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get 60% off",
              "description": "Use code SWIGGYIT & get 60% off on orders above ₹179. Maximum discount: ₹110.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hr on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹10 more to get a discount upto ₹110"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MASTERCARDNEW50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/8/2ebec6c7-0843-4daf-8f21-931da1f17888_4.png",
              "title": "Get FLAT ₹50 cashback by tokenizing your Mastercard",
              "description": "Secure & pay using your Mastercard to get ₹50 cashback into your Swiggy Money wallet on transactions above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the campaign",
                  "Valid only on a minimum transaction value of ₹399",
                  "Cashback will only be processed to the users who have tokenized their Mastercard debit or credit card during the payment",
                  "Cashback will be credited to your Swiggy Money wallet in 15 days from the transaction date",
                  "Other T&Cs may apply",
                  "Offer valid till Apr 30, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 105 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXISREWARDS",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1de7c3ce-0a38-4705-885c-ecd31377f4a8_AxisLogo400X4003.png",
              "title": "Get flat ₹150 OFF using Axis Bank Rewards Credit Cards",
              "description": "Flat ₹150 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Rewards Credit Cards (including all recently migrated ones)",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/9e11b331-7649-44de-a484-eb54bc4df00b_AxisLogo400X4003.png",
              "title": "Get flat ₹200 OFF using Axis Bank Select Credit Cards",
              "description": "Flat ₹200 OFF on orders above ₹1000",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Select Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹831 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS120",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1567725f-af88-42a4-8a7d-2db532b73f04_AxisLogo400X4003.png",
              "title": "Get Flat ₹120 OFF using Axis Bank MY ZONE Credit Cards",
              "description": "Flat ₹120 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank MY ZONE Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "HSBC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/a95eb3f5-251c-406b-80c8-da15ddb0d116_HSBCHexagon400x4001.png",
              "title": "Get 10% discount using select HSBC Credit Cards",
              "description": "Flat 10% discount up to ₹100 using select HSBC Credit Cards on orders above ₹999",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable from Wednesday to Sunday",
                  "Valid once per user during the offer period",
                  "Offer valid only on select HSBC Credit Cards",
                  "Not valid on HSBC Live+/ Cashback Credit Card variant starting with 431104",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹830 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "APAYFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/415f4674-6231-4e40-9378-1fbacb4f20cb_AmazonPayNewLogoJun23.png",
              "title": "Get up to ₹100 cashback using Amazon Pay Balance",
              "description": "Up to ₹100 cashback on Amazon Pay Balance transactions above ₹199",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the offer period",
                  "Valid on the net transaction amount of ₹199 & above using Amazon Pay Balance",
                  "Minimum assured cashback of ₹20 will be available in the form of a scratch card in your Amazon Pay account",
                  "Users are eligible for an assured cashback only once across Food & Instamart",
                  "Valid only for users who have linked their Amazon account and paid using Amazon Pay Balance",
                  "Not valid on payments via Amazon Pay UPI directly from the UPI section or Amazon Pay balance",
                  "The cashback will only be issued once the customer scratches the issued card by going to the Rewards page on Amazon Pay",
                  "Once the scratched card is scratched, cashback will be credited as Amazon Pay Balance within 24 hours",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹30 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISABOBDC",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f387cda5-008f-49c3-b443-6e7cc4873744_VisaBankofBarodaLogo.png",
              "title": "Get 20% discount using Bank of Baroda Visa Debit Cards",
              "description": "Maximum ₹130 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on Bank of Baroda Visa Debit Cards",
                  "Valid only on Monday, Tuesday, Wednesday & Thursday",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "INDUSINDDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/5721e0f9-0d11-4214-b70f-20a8b52e1ae5_IndusIndBankLogoBurgundyTwoLine02.png",
              "title": "Save ₹200 OFF using select IndusInd Bank Debit Cards",
              "description": "Maximum up to ₹200 OFF using IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards on orders above ₹600",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards variants",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹431 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS150",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/4cce62d6-9414-45f4-9d8e-82d689594b8a_AxisLogo400X4003.png",
              "title": "Get 25% OFF using Axis Bank Delight Debit Cards",
              "description": "Maximum up to ₹150 OFF on orders above ₹400",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable thrice per user per calendar month",
                  "Valid only on Axis Bank Delight Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹231 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MBKFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/31d31f7d-e9e2-40ea-b7c2-0f3cece34e78_MobiKwikFoodOffersLogoLatest2.png",
              "title": "Get up to ₹150 cashback using MobiKwik wallet",
              "description": "Assured ₹15 to ₹150 Instant Cashback via Scratch Card on MobiKwik wallet transactions above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per month",
                  "Assured cashback will be ₹15 per transaction",
                  "Valid on the net transaction amount of ₹249 & above using the MobiKwik wallet",
                  "Cashback can be claimed through a Scratch card on the MobiKwik app in the rewards section & the Scratch card will be valid for 7 days only",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/5/9d446beb-b2ce-480f-8b70-58b8e8038001_AUBank400X400Logo.png",
              "title": "Get 20% discount using AU Debit Cards",
              "description": "Maximum up to ₹111 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid only on AU Debit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "PNBCC125",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/e948424c-1683-492c-ad40-dab329505568_PNBFoodOffersLogo.png",
              "title": "Get 15% discount using Punjab National Bank Credit Cards",
              "description": "Maximum discount of ₹125 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Punjab National Bank Credit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZAGGCARD",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/18/361c4086-1746-439a-bd0a-75acbae97c28_ZaggCoinLogo.png",
              "title": "Get 40% discount using Zagg Credit Card",
              "description": "Maximum up to ₹100 OFF on orders above ₹200",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Zagg Credit Cards issued under BIN 356191906",
                  "Applicable once per user during the offer period",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹31 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUCC50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/d8ce833e-602e-4be8-bb61-c51f8dc115cf_AUBank400X400Logo.png",
              "title": "Get 5% discount using AU Credit Cards",
              "description": "Maximum discount of ₹50 on orders above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per month",
                  "Valid only on AU Credit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBICC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f294f5a3-a376-4f5b-87b5-58e9dbc4dbf3_IDBI400X4004.png",
              "title": "Get 15% discount using IDBI Bank Credit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IDBI Bank Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBIDC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ba5c2bab-955a-4ff6-8345-6ec6d96d6631_IDBI400X4004.png",
              "title": "Get 15% discount using select IDBI Bank Debit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on IDBI Bank Platinum & Signature variant Debit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZETCARD100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/b47eb00e-6232-40ab-8c68-24486989a87c_ZET400x400Logo.png",
              "title": "Get Flat ₹100 OFF using ZET Credit Card",
              "description": "Get ZET Credit Card on the Zet App to unlock this Offer, Flat ₹100 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on all ZET cards issued by SBM Bank, IOB, and DCB Bank",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARACC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/abe79014-b8e3-48fc-b05e-e05162ceddd9_CanaraBankVisaNewLogo.png",
              "title": "Get 15% discount using Canara Bank Visa Credit Cards",
              "description": "Maximum discount up to ₹100 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CBIDC75",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/14/4bd1e216-0f03-4326-bda0-fa7e8cb14713_CentralBankOfIndiaFoodOffersLogo.png",
              "title": "Get flat ₹75 discount using Central Bank of India Debit Cards",
              "description": "Flat ₹75 OFF on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid on all Central Bank of India Debit Cards",
                  "Applicable once per user per week",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 21, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 6 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARADC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/8e46ed72-e428-40f1-98e6-032505f8a22f_CanaraBankVisaNewLogo.png",
              "title": "Flat ₹100 OFF",
              "description": "Use Canara Bank Visa Debit Cards to get Flat ₹100 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "NOVIO100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ff4ecf82-7ac5-4b3a-870a-f4464f90a07e_NovioFoodOffersLogo.png",
              "title": "Get flat ₹100 discount using SBM Credilio Credit Card",
              "description": "FLAT ₹100 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Get your guaranteed SBM Credilio Credit Card on the Novio App",
                  "Applicable once per user during the offer period",
                  "Exclusive to SBM Credilio Credit Card holders",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        }
      ]
    },
    "tid": "88cc8a44-ea1a-4fb8-9a9f-20e77fc757a1",
    "sid": "p4p56099-037e-40d8-a215-e0604df50d69",
    "deviceId": "663cd9c7-0449-024f-940c-b517fba567ac",
    "csrfToken": "T1ynGeb80mri-OMY7_9X6y_aGDgtzBlhogVLYZqo"
  },

  "348083": {
    "statusCode": 0,
    "data": {
      "cacheExpiryTime": 320,
      "pages": 2,
      "pageIndex": 0,
      "nextPageFetch": 0,
      "cards": [
        {
          "cardType": "couponApplyWidget",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "couponApplyWidget",
            "data": {
              "textPlaceHolder": "Enter Coupon Code",
              "buttonText": "Apply"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "AVAILABLE COUPONS"
            },
            "subtype": "couponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "UNAVAILABLE COUPONS"
            },
            "subtype": "unavailableCouponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT80",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.80 off",
              "description": "Use code FLAT80 & get flat ₹80 off on orders above ₹249.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to get a Flat ₹80 off"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT150",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs. 150 off",
              "description": "Use code FLAT150 & get flat ₹150 off orders above ₹599.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CELEBRATIONS",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.200 off",
              "description": "Use code CELEBRATION & get ₹200 off on orders above ₹799",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹630 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "SWIGGYIT",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get 60% off",
              "description": "Use code SWIGGYIT & get 60% off on orders above ₹179. Maximum discount: ₹110.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hr on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹10 more to get a discount upto ₹110"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MASTERCARDNEW50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/8/2ebec6c7-0843-4daf-8f21-931da1f17888_4.png",
              "title": "Get FLAT ₹50 cashback by tokenizing your Mastercard",
              "description": "Secure & pay using your Mastercard to get ₹50 cashback into your Swiggy Money wallet on transactions above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the campaign",
                  "Valid only on a minimum transaction value of ₹399",
                  "Cashback will only be processed to the users who have tokenized their Mastercard debit or credit card during the payment",
                  "Cashback will be credited to your Swiggy Money wallet in 15 days from the transaction date",
                  "Other T&Cs may apply",
                  "Offer valid till Apr 30, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 105 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXISREWARDS",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1de7c3ce-0a38-4705-885c-ecd31377f4a8_AxisLogo400X4003.png",
              "title": "Get flat ₹150 OFF using Axis Bank Rewards Credit Cards",
              "description": "Flat ₹150 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Rewards Credit Cards (including all recently migrated ones)",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/9e11b331-7649-44de-a484-eb54bc4df00b_AxisLogo400X4003.png",
              "title": "Get flat ₹200 OFF using Axis Bank Select Credit Cards",
              "description": "Flat ₹200 OFF on orders above ₹1000",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Select Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹831 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS120",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1567725f-af88-42a4-8a7d-2db532b73f04_AxisLogo400X4003.png",
              "title": "Get Flat ₹120 OFF using Axis Bank MY ZONE Credit Cards",
              "description": "Flat ₹120 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank MY ZONE Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "HSBC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/a95eb3f5-251c-406b-80c8-da15ddb0d116_HSBCHexagon400x4001.png",
              "title": "Get 10% discount using select HSBC Credit Cards",
              "description": "Flat 10% discount up to ₹100 using select HSBC Credit Cards on orders above ₹999",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable from Wednesday to Sunday",
                  "Valid once per user during the offer period",
                  "Offer valid only on select HSBC Credit Cards",
                  "Not valid on HSBC Live+/ Cashback Credit Card variant starting with 431104",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹830 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "APAYFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/415f4674-6231-4e40-9378-1fbacb4f20cb_AmazonPayNewLogoJun23.png",
              "title": "Get up to ₹100 cashback using Amazon Pay Balance",
              "description": "Up to ₹100 cashback on Amazon Pay Balance transactions above ₹199",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the offer period",
                  "Valid on the net transaction amount of ₹199 & above using Amazon Pay Balance",
                  "Minimum assured cashback of ₹20 will be available in the form of a scratch card in your Amazon Pay account",
                  "Users are eligible for an assured cashback only once across Food & Instamart",
                  "Valid only for users who have linked their Amazon account and paid using Amazon Pay Balance",
                  "Not valid on payments via Amazon Pay UPI directly from the UPI section or Amazon Pay balance",
                  "The cashback will only be issued once the customer scratches the issued card by going to the Rewards page on Amazon Pay",
                  "Once the scratched card is scratched, cashback will be credited as Amazon Pay Balance within 24 hours",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹30 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISABOBDC",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f387cda5-008f-49c3-b443-6e7cc4873744_VisaBankofBarodaLogo.png",
              "title": "Get 20% discount using Bank of Baroda Visa Debit Cards",
              "description": "Maximum ₹130 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on Bank of Baroda Visa Debit Cards",
                  "Valid only on Monday, Tuesday, Wednesday & Thursday",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "INDUSINDDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/5721e0f9-0d11-4214-b70f-20a8b52e1ae5_IndusIndBankLogoBurgundyTwoLine02.png",
              "title": "Save ₹200 OFF using select IndusInd Bank Debit Cards",
              "description": "Maximum up to ₹200 OFF using IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards on orders above ₹600",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards variants",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹431 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS150",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/4cce62d6-9414-45f4-9d8e-82d689594b8a_AxisLogo400X4003.png",
              "title": "Get 25% OFF using Axis Bank Delight Debit Cards",
              "description": "Maximum up to ₹150 OFF on orders above ₹400",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable thrice per user per calendar month",
                  "Valid only on Axis Bank Delight Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹231 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MBKFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/31d31f7d-e9e2-40ea-b7c2-0f3cece34e78_MobiKwikFoodOffersLogoLatest2.png",
              "title": "Get up to ₹150 cashback using MobiKwik wallet",
              "description": "Assured ₹15 to ₹150 Instant Cashback via Scratch Card on MobiKwik wallet transactions above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per month",
                  "Assured cashback will be ₹15 per transaction",
                  "Valid on the net transaction amount of ₹249 & above using the MobiKwik wallet",
                  "Cashback can be claimed through a Scratch card on the MobiKwik app in the rewards section & the Scratch card will be valid for 7 days only",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/5/9d446beb-b2ce-480f-8b70-58b8e8038001_AUBank400X400Logo.png",
              "title": "Get 20% discount using AU Debit Cards",
              "description": "Maximum up to ₹111 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid only on AU Debit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "PNBCC125",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/e948424c-1683-492c-ad40-dab329505568_PNBFoodOffersLogo.png",
              "title": "Get 15% discount using Punjab National Bank Credit Cards",
              "description": "Maximum discount of ₹125 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Punjab National Bank Credit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZAGGCARD",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/18/361c4086-1746-439a-bd0a-75acbae97c28_ZaggCoinLogo.png",
              "title": "Get 40% discount using Zagg Credit Card",
              "description": "Maximum up to ₹100 OFF on orders above ₹200",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Zagg Credit Cards issued under BIN 356191906",
                  "Applicable once per user during the offer period",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹31 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUCC50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/d8ce833e-602e-4be8-bb61-c51f8dc115cf_AUBank400X400Logo.png",
              "title": "Get 5% discount using AU Credit Cards",
              "description": "Maximum discount of ₹50 on orders above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per month",
                  "Valid only on AU Credit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBICC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f294f5a3-a376-4f5b-87b5-58e9dbc4dbf3_IDBI400X4004.png",
              "title": "Get 15% discount using IDBI Bank Credit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IDBI Bank Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBIDC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ba5c2bab-955a-4ff6-8345-6ec6d96d6631_IDBI400X4004.png",
              "title": "Get 15% discount using select IDBI Bank Debit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on IDBI Bank Platinum & Signature variant Debit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZETCARD100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/b47eb00e-6232-40ab-8c68-24486989a87c_ZET400x400Logo.png",
              "title": "Get Flat ₹100 OFF using ZET Credit Card",
              "description": "Get ZET Credit Card on the Zet App to unlock this Offer, Flat ₹100 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on all ZET cards issued by SBM Bank, IOB, and DCB Bank",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARACC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/abe79014-b8e3-48fc-b05e-e05162ceddd9_CanaraBankVisaNewLogo.png",
              "title": "Get 15% discount using Canara Bank Visa Credit Cards",
              "description": "Maximum discount up to ₹100 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CBIDC75",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/14/4bd1e216-0f03-4326-bda0-fa7e8cb14713_CentralBankOfIndiaFoodOffersLogo.png",
              "title": "Get flat ₹75 discount using Central Bank of India Debit Cards",
              "description": "Flat ₹75 OFF on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid on all Central Bank of India Debit Cards",
                  "Applicable once per user per week",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 21, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 6 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARADC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/8e46ed72-e428-40f1-98e6-032505f8a22f_CanaraBankVisaNewLogo.png",
              "title": "Flat ₹100 OFF",
              "description": "Use Canara Bank Visa Debit Cards to get Flat ₹100 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "NOVIO100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ff4ecf82-7ac5-4b3a-870a-f4464f90a07e_NovioFoodOffersLogo.png",
              "title": "Get flat ₹100 discount using SBM Credilio Credit Card",
              "description": "FLAT ₹100 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Get your guaranteed SBM Credilio Credit Card on the Novio App",
                  "Applicable once per user during the offer period",
                  "Exclusive to SBM Credilio Credit Card holders",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        }
      ]
    },
    "tid": "88cc8a44-ea1a-4fb8-9a9f-20e77fc757a1",
    "sid": "p4p56099-037e-40d8-a215-e0604df50d69",
    "deviceId": "663cd9c7-0449-024f-940c-b517fba567ac",
    "csrfToken": "LkU97XJQr0aA-nHEvEFmTnrtkcZdgaNsjPP_UroA"
  },
  "638996": {
    "statusCode": 0,
    "data": {
      "cacheExpiryTime": 320,
      "pages": 2,
      "pageIndex": 0,
      "nextPageFetch": 0,
      "cards": [
        {
          "cardType": "couponApplyWidget",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "couponApplyWidget",
            "data": {
              "textPlaceHolder": "Enter Coupon Code",
              "buttonText": "Apply"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "AVAILABLE COUPONS"
            },
            "subtype": "couponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "UNAVAILABLE COUPONS"
            },
            "subtype": "unavailableCouponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT80",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.80 off",
              "description": "Use code FLAT80 & get flat ₹80 off on orders above ₹249.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to get a Flat ₹80 off"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT150",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs. 150 off",
              "description": "Use code FLAT150 & get flat ₹150 off orders above ₹599.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CELEBRATIONS",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.200 off",
              "description": "Use code CELEBRATION & get ₹200 off on orders above ₹799",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹630 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "SWIGGYIT",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get 60% off",
              "description": "Use code SWIGGYIT & get 60% off on orders above ₹179. Maximum discount: ₹110.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hr on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹10 more to get a discount upto ₹110"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MASTERCARDNEW50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/8/2ebec6c7-0843-4daf-8f21-931da1f17888_4.png",
              "title": "Get FLAT ₹50 cashback by tokenizing your Mastercard",
              "description": "Secure & pay using your Mastercard to get ₹50 cashback into your Swiggy Money wallet on transactions above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the campaign",
                  "Valid only on a minimum transaction value of ₹399",
                  "Cashback will only be processed to the users who have tokenized their Mastercard debit or credit card during the payment",
                  "Cashback will be credited to your Swiggy Money wallet in 15 days from the transaction date",
                  "Other T&Cs may apply",
                  "Offer valid till Apr 30, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 105 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXISREWARDS",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1de7c3ce-0a38-4705-885c-ecd31377f4a8_AxisLogo400X4003.png",
              "title": "Get flat ₹150 OFF using Axis Bank Rewards Credit Cards",
              "description": "Flat ₹150 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Rewards Credit Cards (including all recently migrated ones)",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/9e11b331-7649-44de-a484-eb54bc4df00b_AxisLogo400X4003.png",
              "title": "Get flat ₹200 OFF using Axis Bank Select Credit Cards",
              "description": "Flat ₹200 OFF on orders above ₹1000",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Select Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹831 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS120",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1567725f-af88-42a4-8a7d-2db532b73f04_AxisLogo400X4003.png",
              "title": "Get Flat ₹120 OFF using Axis Bank MY ZONE Credit Cards",
              "description": "Flat ₹120 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank MY ZONE Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "HSBC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/a95eb3f5-251c-406b-80c8-da15ddb0d116_HSBCHexagon400x4001.png",
              "title": "Get 10% discount using select HSBC Credit Cards",
              "description": "Flat 10% discount up to ₹100 using select HSBC Credit Cards on orders above ₹999",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable from Wednesday to Sunday",
                  "Valid once per user during the offer period",
                  "Offer valid only on select HSBC Credit Cards",
                  "Not valid on HSBC Live+/ Cashback Credit Card variant starting with 431104",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹830 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "APAYFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/415f4674-6231-4e40-9378-1fbacb4f20cb_AmazonPayNewLogoJun23.png",
              "title": "Get up to ₹100 cashback using Amazon Pay Balance",
              "description": "Up to ₹100 cashback on Amazon Pay Balance transactions above ₹199",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the offer period",
                  "Valid on the net transaction amount of ₹199 & above using Amazon Pay Balance",
                  "Minimum assured cashback of ₹20 will be available in the form of a scratch card in your Amazon Pay account",
                  "Users are eligible for an assured cashback only once across Food & Instamart",
                  "Valid only for users who have linked their Amazon account and paid using Amazon Pay Balance",
                  "Not valid on payments via Amazon Pay UPI directly from the UPI section or Amazon Pay balance",
                  "The cashback will only be issued once the customer scratches the issued card by going to the Rewards page on Amazon Pay",
                  "Once the scratched card is scratched, cashback will be credited as Amazon Pay Balance within 24 hours",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹30 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISABOBDC",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f387cda5-008f-49c3-b443-6e7cc4873744_VisaBankofBarodaLogo.png",
              "title": "Get 20% discount using Bank of Baroda Visa Debit Cards",
              "description": "Maximum ₹130 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on Bank of Baroda Visa Debit Cards",
                  "Valid only on Monday, Tuesday, Wednesday & Thursday",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "INDUSINDDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/5721e0f9-0d11-4214-b70f-20a8b52e1ae5_IndusIndBankLogoBurgundyTwoLine02.png",
              "title": "Save ₹200 OFF using select IndusInd Bank Debit Cards",
              "description": "Maximum up to ₹200 OFF using IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards on orders above ₹600",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards variants",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹431 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS150",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/4cce62d6-9414-45f4-9d8e-82d689594b8a_AxisLogo400X4003.png",
              "title": "Get 25% OFF using Axis Bank Delight Debit Cards",
              "description": "Maximum up to ₹150 OFF on orders above ₹400",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable thrice per user per calendar month",
                  "Valid only on Axis Bank Delight Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹231 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MBKFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/31d31f7d-e9e2-40ea-b7c2-0f3cece34e78_MobiKwikFoodOffersLogoLatest2.png",
              "title": "Get up to ₹150 cashback using MobiKwik wallet",
              "description": "Assured ₹15 to ₹150 Instant Cashback via Scratch Card on MobiKwik wallet transactions above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per month",
                  "Assured cashback will be ₹15 per transaction",
                  "Valid on the net transaction amount of ₹249 & above using the MobiKwik wallet",
                  "Cashback can be claimed through a Scratch card on the MobiKwik app in the rewards section & the Scratch card will be valid for 7 days only",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/5/9d446beb-b2ce-480f-8b70-58b8e8038001_AUBank400X400Logo.png",
              "title": "Get 20% discount using AU Debit Cards",
              "description": "Maximum up to ₹111 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid only on AU Debit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "PNBCC125",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/e948424c-1683-492c-ad40-dab329505568_PNBFoodOffersLogo.png",
              "title": "Get 15% discount using Punjab National Bank Credit Cards",
              "description": "Maximum discount of ₹125 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Punjab National Bank Credit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZAGGCARD",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/18/361c4086-1746-439a-bd0a-75acbae97c28_ZaggCoinLogo.png",
              "title": "Get 40% discount using Zagg Credit Card",
              "description": "Maximum up to ₹100 OFF on orders above ₹200",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Zagg Credit Cards issued under BIN 356191906",
                  "Applicable once per user during the offer period",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹31 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUCC50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/d8ce833e-602e-4be8-bb61-c51f8dc115cf_AUBank400X400Logo.png",
              "title": "Get 5% discount using AU Credit Cards",
              "description": "Maximum discount of ₹50 on orders above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per month",
                  "Valid only on AU Credit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBICC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f294f5a3-a376-4f5b-87b5-58e9dbc4dbf3_IDBI400X4004.png",
              "title": "Get 15% discount using IDBI Bank Credit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IDBI Bank Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBIDC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ba5c2bab-955a-4ff6-8345-6ec6d96d6631_IDBI400X4004.png",
              "title": "Get 15% discount using select IDBI Bank Debit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on IDBI Bank Platinum & Signature variant Debit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZETCARD100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/b47eb00e-6232-40ab-8c68-24486989a87c_ZET400x400Logo.png",
              "title": "Get Flat ₹100 OFF using ZET Credit Card",
              "description": "Get ZET Credit Card on the Zet App to unlock this Offer, Flat ₹100 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on all ZET cards issued by SBM Bank, IOB, and DCB Bank",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARACC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/abe79014-b8e3-48fc-b05e-e05162ceddd9_CanaraBankVisaNewLogo.png",
              "title": "Get 15% discount using Canara Bank Visa Credit Cards",
              "description": "Maximum discount up to ₹100 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CBIDC75",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/14/4bd1e216-0f03-4326-bda0-fa7e8cb14713_CentralBankOfIndiaFoodOffersLogo.png",
              "title": "Get flat ₹75 discount using Central Bank of India Debit Cards",
              "description": "Flat ₹75 OFF on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid on all Central Bank of India Debit Cards",
                  "Applicable once per user per week",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 21, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 6 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARADC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/8e46ed72-e428-40f1-98e6-032505f8a22f_CanaraBankVisaNewLogo.png",
              "title": "Flat ₹100 OFF",
              "description": "Use Canara Bank Visa Debit Cards to get Flat ₹100 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "NOVIO100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ff4ecf82-7ac5-4b3a-870a-f4464f90a07e_NovioFoodOffersLogo.png",
              "title": "Get flat ₹100 discount using SBM Credilio Credit Card",
              "description": "FLAT ₹100 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Get your guaranteed SBM Credilio Credit Card on the Novio App",
                  "Applicable once per user during the offer period",
                  "Exclusive to SBM Credilio Credit Card holders",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        }
      ]
    },
    "tid": "88cc8a44-ea1a-4fb8-9a9f-20e77fc757a1",
    "sid": "p4p56099-037e-40d8-a215-e0604df50d69",
    "deviceId": "663cd9c7-0449-024f-940c-b517fba567ac",
    "csrfToken": "NhH5Dod0rwns-HurFH0f_sn6QrRQB1XhwKDrvYZY"
  },
  "79807": {
    "statusCode": 0,
    "data": {
      "cacheExpiryTime": 320,
      "pages": 2,
      "pageIndex": 0,
      "nextPageFetch": 0,
      "cards": [
        {
          "cardType": "couponApplyWidget",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "couponApplyWidget",
            "data": {
              "textPlaceHolder": "Enter Coupon Code",
              "buttonText": "Apply"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "AVAILABLE COUPONS"
            },
            "subtype": "couponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "UNAVAILABLE COUPONS"
            },
            "subtype": "unavailableCouponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT80",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.80 off",
              "description": "Use code FLAT80 & get flat ₹80 off on orders above ₹249.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to get a Flat ₹80 off"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT150",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs. 150 off",
              "description": "Use code FLAT150 & get flat ₹150 off orders above ₹599.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CELEBRATIONS",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.200 off",
              "description": "Use code CELEBRATION & get ₹200 off on orders above ₹799",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹630 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "SWIGGYIT",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get 60% off",
              "description": "Use code SWIGGYIT & get 60% off on orders above ₹179. Maximum discount: ₹110.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hr on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹10 more to get a discount upto ₹110"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MASTERCARDNEW50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/8/2ebec6c7-0843-4daf-8f21-931da1f17888_4.png",
              "title": "Get FLAT ₹50 cashback by tokenizing your Mastercard",
              "description": "Secure & pay using your Mastercard to get ₹50 cashback into your Swiggy Money wallet on transactions above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the campaign",
                  "Valid only on a minimum transaction value of ₹399",
                  "Cashback will only be processed to the users who have tokenized their Mastercard debit or credit card during the payment",
                  "Cashback will be credited to your Swiggy Money wallet in 15 days from the transaction date",
                  "Other T&Cs may apply",
                  "Offer valid till Apr 30, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 105 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXISREWARDS",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1de7c3ce-0a38-4705-885c-ecd31377f4a8_AxisLogo400X4003.png",
              "title": "Get flat ₹150 OFF using Axis Bank Rewards Credit Cards",
              "description": "Flat ₹150 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Rewards Credit Cards (including all recently migrated ones)",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/9e11b331-7649-44de-a484-eb54bc4df00b_AxisLogo400X4003.png",
              "title": "Get flat ₹200 OFF using Axis Bank Select Credit Cards",
              "description": "Flat ₹200 OFF on orders above ₹1000",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Select Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹831 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS120",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1567725f-af88-42a4-8a7d-2db532b73f04_AxisLogo400X4003.png",
              "title": "Get Flat ₹120 OFF using Axis Bank MY ZONE Credit Cards",
              "description": "Flat ₹120 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank MY ZONE Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "HSBC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/a95eb3f5-251c-406b-80c8-da15ddb0d116_HSBCHexagon400x4001.png",
              "title": "Get 10% discount using select HSBC Credit Cards",
              "description": "Flat 10% discount up to ₹100 using select HSBC Credit Cards on orders above ₹999",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable from Wednesday to Sunday",
                  "Valid once per user during the offer period",
                  "Offer valid only on select HSBC Credit Cards",
                  "Not valid on HSBC Live+/ Cashback Credit Card variant starting with 431104",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹830 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "APAYFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/415f4674-6231-4e40-9378-1fbacb4f20cb_AmazonPayNewLogoJun23.png",
              "title": "Get up to ₹100 cashback using Amazon Pay Balance",
              "description": "Up to ₹100 cashback on Amazon Pay Balance transactions above ₹199",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the offer period",
                  "Valid on the net transaction amount of ₹199 & above using Amazon Pay Balance",
                  "Minimum assured cashback of ₹20 will be available in the form of a scratch card in your Amazon Pay account",
                  "Users are eligible for an assured cashback only once across Food & Instamart",
                  "Valid only for users who have linked their Amazon account and paid using Amazon Pay Balance",
                  "Not valid on payments via Amazon Pay UPI directly from the UPI section or Amazon Pay balance",
                  "The cashback will only be issued once the customer scratches the issued card by going to the Rewards page on Amazon Pay",
                  "Once the scratched card is scratched, cashback will be credited as Amazon Pay Balance within 24 hours",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹30 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISABOBDC",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f387cda5-008f-49c3-b443-6e7cc4873744_VisaBankofBarodaLogo.png",
              "title": "Get 20% discount using Bank of Baroda Visa Debit Cards",
              "description": "Maximum ₹130 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on Bank of Baroda Visa Debit Cards",
                  "Valid only on Monday, Tuesday, Wednesday & Thursday",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "INDUSINDDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/5721e0f9-0d11-4214-b70f-20a8b52e1ae5_IndusIndBankLogoBurgundyTwoLine02.png",
              "title": "Save ₹200 OFF using select IndusInd Bank Debit Cards",
              "description": "Maximum up to ₹200 OFF using IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards on orders above ₹600",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards variants",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹431 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS150",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/4cce62d6-9414-45f4-9d8e-82d689594b8a_AxisLogo400X4003.png",
              "title": "Get 25% OFF using Axis Bank Delight Debit Cards",
              "description": "Maximum up to ₹150 OFF on orders above ₹400",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable thrice per user per calendar month",
                  "Valid only on Axis Bank Delight Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹231 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MBKFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/31d31f7d-e9e2-40ea-b7c2-0f3cece34e78_MobiKwikFoodOffersLogoLatest2.png",
              "title": "Get up to ₹150 cashback using MobiKwik wallet",
              "description": "Assured ₹15 to ₹150 Instant Cashback via Scratch Card on MobiKwik wallet transactions above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per month",
                  "Assured cashback will be ₹15 per transaction",
                  "Valid on the net transaction amount of ₹249 & above using the MobiKwik wallet",
                  "Cashback can be claimed through a Scratch card on the MobiKwik app in the rewards section & the Scratch card will be valid for 7 days only",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/5/9d446beb-b2ce-480f-8b70-58b8e8038001_AUBank400X400Logo.png",
              "title": "Get 20% discount using AU Debit Cards",
              "description": "Maximum up to ₹111 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid only on AU Debit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "PNBCC125",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/e948424c-1683-492c-ad40-dab329505568_PNBFoodOffersLogo.png",
              "title": "Get 15% discount using Punjab National Bank Credit Cards",
              "description": "Maximum discount of ₹125 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Punjab National Bank Credit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZAGGCARD",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/18/361c4086-1746-439a-bd0a-75acbae97c28_ZaggCoinLogo.png",
              "title": "Get 40% discount using Zagg Credit Card",
              "description": "Maximum up to ₹100 OFF on orders above ₹200",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Zagg Credit Cards issued under BIN 356191906",
                  "Applicable once per user during the offer period",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹31 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUCC50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/d8ce833e-602e-4be8-bb61-c51f8dc115cf_AUBank400X400Logo.png",
              "title": "Get 5% discount using AU Credit Cards",
              "description": "Maximum discount of ₹50 on orders above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per month",
                  "Valid only on AU Credit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBICC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f294f5a3-a376-4f5b-87b5-58e9dbc4dbf3_IDBI400X4004.png",
              "title": "Get 15% discount using IDBI Bank Credit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IDBI Bank Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBIDC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ba5c2bab-955a-4ff6-8345-6ec6d96d6631_IDBI400X4004.png",
              "title": "Get 15% discount using select IDBI Bank Debit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on IDBI Bank Platinum & Signature variant Debit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZETCARD100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/b47eb00e-6232-40ab-8c68-24486989a87c_ZET400x400Logo.png",
              "title": "Get Flat ₹100 OFF using ZET Credit Card",
              "description": "Get ZET Credit Card on the Zet App to unlock this Offer, Flat ₹100 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on all ZET cards issued by SBM Bank, IOB, and DCB Bank",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARACC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/abe79014-b8e3-48fc-b05e-e05162ceddd9_CanaraBankVisaNewLogo.png",
              "title": "Get 15% discount using Canara Bank Visa Credit Cards",
              "description": "Maximum discount up to ₹100 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CBIDC75",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/14/4bd1e216-0f03-4326-bda0-fa7e8cb14713_CentralBankOfIndiaFoodOffersLogo.png",
              "title": "Get flat ₹75 discount using Central Bank of India Debit Cards",
              "description": "Flat ₹75 OFF on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid on all Central Bank of India Debit Cards",
                  "Applicable once per user per week",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 21, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 6 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARADC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/8e46ed72-e428-40f1-98e6-032505f8a22f_CanaraBankVisaNewLogo.png",
              "title": "Flat ₹100 OFF",
              "description": "Use Canara Bank Visa Debit Cards to get Flat ₹100 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "NOVIO100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ff4ecf82-7ac5-4b3a-870a-f4464f90a07e_NovioFoodOffersLogo.png",
              "title": "Get flat ₹100 discount using SBM Credilio Credit Card",
              "description": "FLAT ₹100 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Get your guaranteed SBM Credilio Credit Card on the Novio App",
                  "Applicable once per user during the offer period",
                  "Exclusive to SBM Credilio Credit Card holders",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        }
      ]
    },
    "tid": "88cc8a44-ea1a-4fb8-9a9f-20e77fc757a1",
    "sid": "p4p56099-037e-40d8-a215-e0604df50d69",
    "deviceId": "663cd9c7-0449-024f-940c-b517fba567ac",
    "csrfToken": "glZEqu8hACbh-r5E15MeQ97OxXeHuREJwTX96_xo"
  },
  "79893": {
    "statusCode": 0,
    "data": {
      "cacheExpiryTime": 320,
      "pages": 2,
      "pageIndex": 0,
      "nextPageFetch": 0,
      "cards": [
        {
          "cardType": "couponApplyWidget",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "couponApplyWidget",
            "data": {
              "textPlaceHolder": "Enter Coupon Code",
              "buttonText": "Apply"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "AVAILABLE COUPONS"
            },
            "subtype": "couponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "UNAVAILABLE COUPONS"
            },
            "subtype": "unavailableCouponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT80",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.80 off",
              "description": "Use code FLAT80 & get flat ₹80 off on orders above ₹249.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to get a Flat ₹80 off"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT150",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs. 150 off",
              "description": "Use code FLAT150 & get flat ₹150 off orders above ₹599.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CELEBRATIONS",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.200 off",
              "description": "Use code CELEBRATION & get ₹200 off on orders above ₹799",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹630 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "SWIGGYIT",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get 60% off",
              "description": "Use code SWIGGYIT & get 60% off on orders above ₹179. Maximum discount: ₹110.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hr on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹10 more to get a discount upto ₹110"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MASTERCARDNEW50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/8/2ebec6c7-0843-4daf-8f21-931da1f17888_4.png",
              "title": "Get FLAT ₹50 cashback by tokenizing your Mastercard",
              "description": "Secure & pay using your Mastercard to get ₹50 cashback into your Swiggy Money wallet on transactions above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the campaign",
                  "Valid only on a minimum transaction value of ₹399",
                  "Cashback will only be processed to the users who have tokenized their Mastercard debit or credit card during the payment",
                  "Cashback will be credited to your Swiggy Money wallet in 15 days from the transaction date",
                  "Other T&Cs may apply",
                  "Offer valid till Apr 30, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 105 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXISREWARDS",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1de7c3ce-0a38-4705-885c-ecd31377f4a8_AxisLogo400X4003.png",
              "title": "Get flat ₹150 OFF using Axis Bank Rewards Credit Cards",
              "description": "Flat ₹150 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Rewards Credit Cards (including all recently migrated ones)",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/9e11b331-7649-44de-a484-eb54bc4df00b_AxisLogo400X4003.png",
              "title": "Get flat ₹200 OFF using Axis Bank Select Credit Cards",
              "description": "Flat ₹200 OFF on orders above ₹1000",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Select Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹831 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS120",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1567725f-af88-42a4-8a7d-2db532b73f04_AxisLogo400X4003.png",
              "title": "Get Flat ₹120 OFF using Axis Bank MY ZONE Credit Cards",
              "description": "Flat ₹120 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank MY ZONE Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "HSBC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/a95eb3f5-251c-406b-80c8-da15ddb0d116_HSBCHexagon400x4001.png",
              "title": "Get 10% discount using select HSBC Credit Cards",
              "description": "Flat 10% discount up to ₹100 using select HSBC Credit Cards on orders above ₹999",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable from Wednesday to Sunday",
                  "Valid once per user during the offer period",
                  "Offer valid only on select HSBC Credit Cards",
                  "Not valid on HSBC Live+/ Cashback Credit Card variant starting with 431104",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹830 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "APAYFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/415f4674-6231-4e40-9378-1fbacb4f20cb_AmazonPayNewLogoJun23.png",
              "title": "Get up to ₹100 cashback using Amazon Pay Balance",
              "description": "Up to ₹100 cashback on Amazon Pay Balance transactions above ₹199",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the offer period",
                  "Valid on the net transaction amount of ₹199 & above using Amazon Pay Balance",
                  "Minimum assured cashback of ₹20 will be available in the form of a scratch card in your Amazon Pay account",
                  "Users are eligible for an assured cashback only once across Food & Instamart",
                  "Valid only for users who have linked their Amazon account and paid using Amazon Pay Balance",
                  "Not valid on payments via Amazon Pay UPI directly from the UPI section or Amazon Pay balance",
                  "The cashback will only be issued once the customer scratches the issued card by going to the Rewards page on Amazon Pay",
                  "Once the scratched card is scratched, cashback will be credited as Amazon Pay Balance within 24 hours",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹30 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISABOBDC",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f387cda5-008f-49c3-b443-6e7cc4873744_VisaBankofBarodaLogo.png",
              "title": "Get 20% discount using Bank of Baroda Visa Debit Cards",
              "description": "Maximum ₹130 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on Bank of Baroda Visa Debit Cards",
                  "Valid only on Monday, Tuesday, Wednesday & Thursday",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "INDUSINDDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/5721e0f9-0d11-4214-b70f-20a8b52e1ae5_IndusIndBankLogoBurgundyTwoLine02.png",
              "title": "Save ₹200 OFF using select IndusInd Bank Debit Cards",
              "description": "Maximum up to ₹200 OFF using IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards on orders above ₹600",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards variants",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹431 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS150",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/4cce62d6-9414-45f4-9d8e-82d689594b8a_AxisLogo400X4003.png",
              "title": "Get 25% OFF using Axis Bank Delight Debit Cards",
              "description": "Maximum up to ₹150 OFF on orders above ₹400",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable thrice per user per calendar month",
                  "Valid only on Axis Bank Delight Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹231 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MBKFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/31d31f7d-e9e2-40ea-b7c2-0f3cece34e78_MobiKwikFoodOffersLogoLatest2.png",
              "title": "Get up to ₹150 cashback using MobiKwik wallet",
              "description": "Assured ₹15 to ₹150 Instant Cashback via Scratch Card on MobiKwik wallet transactions above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per month",
                  "Assured cashback will be ₹15 per transaction",
                  "Valid on the net transaction amount of ₹249 & above using the MobiKwik wallet",
                  "Cashback can be claimed through a Scratch card on the MobiKwik app in the rewards section & the Scratch card will be valid for 7 days only",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/5/9d446beb-b2ce-480f-8b70-58b8e8038001_AUBank400X400Logo.png",
              "title": "Get 20% discount using AU Debit Cards",
              "description": "Maximum up to ₹111 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid only on AU Debit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "PNBCC125",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/e948424c-1683-492c-ad40-dab329505568_PNBFoodOffersLogo.png",
              "title": "Get 15% discount using Punjab National Bank Credit Cards",
              "description": "Maximum discount of ₹125 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Punjab National Bank Credit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZAGGCARD",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/18/361c4086-1746-439a-bd0a-75acbae97c28_ZaggCoinLogo.png",
              "title": "Get 40% discount using Zagg Credit Card",
              "description": "Maximum up to ₹100 OFF on orders above ₹200",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Zagg Credit Cards issued under BIN 356191906",
                  "Applicable once per user during the offer period",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹31 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUCC50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/d8ce833e-602e-4be8-bb61-c51f8dc115cf_AUBank400X400Logo.png",
              "title": "Get 5% discount using AU Credit Cards",
              "description": "Maximum discount of ₹50 on orders above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per month",
                  "Valid only on AU Credit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBICC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f294f5a3-a376-4f5b-87b5-58e9dbc4dbf3_IDBI400X4004.png",
              "title": "Get 15% discount using IDBI Bank Credit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IDBI Bank Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBIDC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ba5c2bab-955a-4ff6-8345-6ec6d96d6631_IDBI400X4004.png",
              "title": "Get 15% discount using select IDBI Bank Debit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on IDBI Bank Platinum & Signature variant Debit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZETCARD100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/b47eb00e-6232-40ab-8c68-24486989a87c_ZET400x400Logo.png",
              "title": "Get Flat ₹100 OFF using ZET Credit Card",
              "description": "Get ZET Credit Card on the Zet App to unlock this Offer, Flat ₹100 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on all ZET cards issued by SBM Bank, IOB, and DCB Bank",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARACC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/abe79014-b8e3-48fc-b05e-e05162ceddd9_CanaraBankVisaNewLogo.png",
              "title": "Get 15% discount using Canara Bank Visa Credit Cards",
              "description": "Maximum discount up to ₹100 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CBIDC75",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/14/4bd1e216-0f03-4326-bda0-fa7e8cb14713_CentralBankOfIndiaFoodOffersLogo.png",
              "title": "Get flat ₹75 discount using Central Bank of India Debit Cards",
              "description": "Flat ₹75 OFF on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid on all Central Bank of India Debit Cards",
                  "Applicable once per user per week",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 21, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 6 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARADC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/8e46ed72-e428-40f1-98e6-032505f8a22f_CanaraBankVisaNewLogo.png",
              "title": "Flat ₹100 OFF",
              "description": "Use Canara Bank Visa Debit Cards to get Flat ₹100 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "NOVIO100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ff4ecf82-7ac5-4b3a-870a-f4464f90a07e_NovioFoodOffersLogo.png",
              "title": "Get flat ₹100 discount using SBM Credilio Credit Card",
              "description": "FLAT ₹100 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Get your guaranteed SBM Credilio Credit Card on the Novio App",
                  "Applicable once per user during the offer period",
                  "Exclusive to SBM Credilio Credit Card holders",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        }
      ]
    },
    "tid": "88cc8a44-ea1a-4fb8-9a9f-20e77fc757a1",
    "sid": "p4p56099-037e-40d8-a215-e0604df50d69",
    "deviceId": "663cd9c7-0449-024f-940c-b517fba567ac",
    "csrfToken": "n3MXzJfYRDPB-ITjR5FmE6dS0aEoj367EqQBR1VE"
  },
  "699962": {
    "statusCode": 0,
    "data": {
      "cacheExpiryTime": 320,
      "pages": 2,
      "pageIndex": 0,
      "nextPageFetch": 0,
      "cards": [
        {
          "cardType": "couponApplyWidget",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "couponApplyWidget",
            "data": {
              "textPlaceHolder": "Enter Coupon Code",
              "buttonText": "Apply"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "AVAILABLE COUPONS"
            },
            "subtype": "couponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "UNAVAILABLE COUPONS"
            },
            "subtype": "unavailableCouponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT80",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.80 off",
              "description": "Use code FLAT80 & get flat ₹80 off on orders above ₹249.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to get a Flat ₹80 off"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT150",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs. 150 off",
              "description": "Use code FLAT150 & get flat ₹150 off orders above ₹599.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CELEBRATIONS",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.200 off",
              "description": "Use code CELEBRATION & get ₹200 off on orders above ₹799",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹630 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "SWIGGYIT",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get 60% off",
              "description": "Use code SWIGGYIT & get 60% off on orders above ₹179. Maximum discount: ₹110.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hr on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹10 more to get a discount upto ₹110"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MASTERCARDNEW50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/8/2ebec6c7-0843-4daf-8f21-931da1f17888_4.png",
              "title": "Get FLAT ₹50 cashback by tokenizing your Mastercard",
              "description": "Secure & pay using your Mastercard to get ₹50 cashback into your Swiggy Money wallet on transactions above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the campaign",
                  "Valid only on a minimum transaction value of ₹399",
                  "Cashback will only be processed to the users who have tokenized their Mastercard debit or credit card during the payment",
                  "Cashback will be credited to your Swiggy Money wallet in 15 days from the transaction date",
                  "Other T&Cs may apply",
                  "Offer valid till Apr 30, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 105 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXISREWARDS",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1de7c3ce-0a38-4705-885c-ecd31377f4a8_AxisLogo400X4003.png",
              "title": "Get flat ₹150 OFF using Axis Bank Rewards Credit Cards",
              "description": "Flat ₹150 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Rewards Credit Cards (including all recently migrated ones)",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/9e11b331-7649-44de-a484-eb54bc4df00b_AxisLogo400X4003.png",
              "title": "Get flat ₹200 OFF using Axis Bank Select Credit Cards",
              "description": "Flat ₹200 OFF on orders above ₹1000",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Select Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹831 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS120",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1567725f-af88-42a4-8a7d-2db532b73f04_AxisLogo400X4003.png",
              "title": "Get Flat ₹120 OFF using Axis Bank MY ZONE Credit Cards",
              "description": "Flat ₹120 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank MY ZONE Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "HSBC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/a95eb3f5-251c-406b-80c8-da15ddb0d116_HSBCHexagon400x4001.png",
              "title": "Get 10% discount using select HSBC Credit Cards",
              "description": "Flat 10% discount up to ₹100 using select HSBC Credit Cards on orders above ₹999",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable from Wednesday to Sunday",
                  "Valid once per user during the offer period",
                  "Offer valid only on select HSBC Credit Cards",
                  "Not valid on HSBC Live+/ Cashback Credit Card variant starting with 431104",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹830 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "APAYFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/415f4674-6231-4e40-9378-1fbacb4f20cb_AmazonPayNewLogoJun23.png",
              "title": "Get up to ₹100 cashback using Amazon Pay Balance",
              "description": "Up to ₹100 cashback on Amazon Pay Balance transactions above ₹199",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the offer period",
                  "Valid on the net transaction amount of ₹199 & above using Amazon Pay Balance",
                  "Minimum assured cashback of ₹20 will be available in the form of a scratch card in your Amazon Pay account",
                  "Users are eligible for an assured cashback only once across Food & Instamart",
                  "Valid only for users who have linked their Amazon account and paid using Amazon Pay Balance",
                  "Not valid on payments via Amazon Pay UPI directly from the UPI section or Amazon Pay balance",
                  "The cashback will only be issued once the customer scratches the issued card by going to the Rewards page on Amazon Pay",
                  "Once the scratched card is scratched, cashback will be credited as Amazon Pay Balance within 24 hours",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹30 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISABOBDC",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f387cda5-008f-49c3-b443-6e7cc4873744_VisaBankofBarodaLogo.png",
              "title": "Get 20% discount using Bank of Baroda Visa Debit Cards",
              "description": "Maximum ₹130 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on Bank of Baroda Visa Debit Cards",
                  "Valid only on Monday, Tuesday, Wednesday & Thursday",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "INDUSINDDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/5721e0f9-0d11-4214-b70f-20a8b52e1ae5_IndusIndBankLogoBurgundyTwoLine02.png",
              "title": "Save ₹200 OFF using select IndusInd Bank Debit Cards",
              "description": "Maximum up to ₹200 OFF using IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards on orders above ₹600",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards variants",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹431 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS150",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/4cce62d6-9414-45f4-9d8e-82d689594b8a_AxisLogo400X4003.png",
              "title": "Get 25% OFF using Axis Bank Delight Debit Cards",
              "description": "Maximum up to ₹150 OFF on orders above ₹400",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable thrice per user per calendar month",
                  "Valid only on Axis Bank Delight Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹231 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MBKFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/31d31f7d-e9e2-40ea-b7c2-0f3cece34e78_MobiKwikFoodOffersLogoLatest2.png",
              "title": "Get up to ₹150 cashback using MobiKwik wallet",
              "description": "Assured ₹15 to ₹150 Instant Cashback via Scratch Card on MobiKwik wallet transactions above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per month",
                  "Assured cashback will be ₹15 per transaction",
                  "Valid on the net transaction amount of ₹249 & above using the MobiKwik wallet",
                  "Cashback can be claimed through a Scratch card on the MobiKwik app in the rewards section & the Scratch card will be valid for 7 days only",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/5/9d446beb-b2ce-480f-8b70-58b8e8038001_AUBank400X400Logo.png",
              "title": "Get 20% discount using AU Debit Cards",
              "description": "Maximum up to ₹111 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid only on AU Debit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "PNBCC125",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/e948424c-1683-492c-ad40-dab329505568_PNBFoodOffersLogo.png",
              "title": "Get 15% discount using Punjab National Bank Credit Cards",
              "description": "Maximum discount of ₹125 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Punjab National Bank Credit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZAGGCARD",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/18/361c4086-1746-439a-bd0a-75acbae97c28_ZaggCoinLogo.png",
              "title": "Get 40% discount using Zagg Credit Card",
              "description": "Maximum up to ₹100 OFF on orders above ₹200",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Zagg Credit Cards issued under BIN 356191906",
                  "Applicable once per user during the offer period",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹31 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUCC50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/d8ce833e-602e-4be8-bb61-c51f8dc115cf_AUBank400X400Logo.png",
              "title": "Get 5% discount using AU Credit Cards",
              "description": "Maximum discount of ₹50 on orders above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per month",
                  "Valid only on AU Credit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBICC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f294f5a3-a376-4f5b-87b5-58e9dbc4dbf3_IDBI400X4004.png",
              "title": "Get 15% discount using IDBI Bank Credit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IDBI Bank Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBIDC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ba5c2bab-955a-4ff6-8345-6ec6d96d6631_IDBI400X4004.png",
              "title": "Get 15% discount using select IDBI Bank Debit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on IDBI Bank Platinum & Signature variant Debit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZETCARD100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/b47eb00e-6232-40ab-8c68-24486989a87c_ZET400x400Logo.png",
              "title": "Get Flat ₹100 OFF using ZET Credit Card",
              "description": "Get ZET Credit Card on the Zet App to unlock this Offer, Flat ₹100 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on all ZET cards issued by SBM Bank, IOB, and DCB Bank",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARACC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/abe79014-b8e3-48fc-b05e-e05162ceddd9_CanaraBankVisaNewLogo.png",
              "title": "Get 15% discount using Canara Bank Visa Credit Cards",
              "description": "Maximum discount up to ₹100 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CBIDC75",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/14/4bd1e216-0f03-4326-bda0-fa7e8cb14713_CentralBankOfIndiaFoodOffersLogo.png",
              "title": "Get flat ₹75 discount using Central Bank of India Debit Cards",
              "description": "Flat ₹75 OFF on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid on all Central Bank of India Debit Cards",
                  "Applicable once per user per week",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 21, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 6 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARADC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/8e46ed72-e428-40f1-98e6-032505f8a22f_CanaraBankVisaNewLogo.png",
              "title": "Flat ₹100 OFF",
              "description": "Use Canara Bank Visa Debit Cards to get Flat ₹100 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "NOVIO100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ff4ecf82-7ac5-4b3a-870a-f4464f90a07e_NovioFoodOffersLogo.png",
              "title": "Get flat ₹100 discount using SBM Credilio Credit Card",
              "description": "FLAT ₹100 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Get your guaranteed SBM Credilio Credit Card on the Novio App",
                  "Applicable once per user during the offer period",
                  "Exclusive to SBM Credilio Credit Card holders",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        }
      ]
    },
    "tid": "88cc8a44-ea1a-4fb8-9a9f-20e77fc757a1",
    "sid": "p4p56099-037e-40d8-a215-e0604df50d69",
    "deviceId": "663cd9c7-0449-024f-940c-b517fba567ac",
    "csrfToken": "WnbvjPWoTepV-n0-uy7xs9LYcSW58ac4xaY5QYTo"
  },
  "111736": {
    "statusCode": 0,
    "data": {
      "cacheExpiryTime": 320,
      "pages": 2,
      "pageIndex": 0,
      "nextPageFetch": 0,
      "cards": [
        {
          "cardType": "couponApplyWidget",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "couponApplyWidget",
            "data": {
              "textPlaceHolder": "Enter Coupon Code",
              "buttonText": "Apply"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "AVAILABLE COUPONS"
            },
            "subtype": "couponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "UNAVAILABLE COUPONS"
            },
            "subtype": "unavailableCouponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT80",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.80 off",
              "description": "Use code FLAT80 & get flat ₹80 off on orders above ₹249.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to get a Flat ₹80 off"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT150",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs. 150 off",
              "description": "Use code FLAT150 & get flat ₹150 off orders above ₹599.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CELEBRATIONS",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.200 off",
              "description": "Use code CELEBRATION & get ₹200 off on orders above ₹799",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹630 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "SWIGGYIT",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get 60% off",
              "description": "Use code SWIGGYIT & get 60% off on orders above ₹179. Maximum discount: ₹110.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hr on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹10 more to get a discount upto ₹110"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MASTERCARDNEW50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/8/2ebec6c7-0843-4daf-8f21-931da1f17888_4.png",
              "title": "Get FLAT ₹50 cashback by tokenizing your Mastercard",
              "description": "Secure & pay using your Mastercard to get ₹50 cashback into your Swiggy Money wallet on transactions above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the campaign",
                  "Valid only on a minimum transaction value of ₹399",
                  "Cashback will only be processed to the users who have tokenized their Mastercard debit or credit card during the payment",
                  "Cashback will be credited to your Swiggy Money wallet in 15 days from the transaction date",
                  "Other T&Cs may apply",
                  "Offer valid till Apr 30, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 105 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXISREWARDS",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1de7c3ce-0a38-4705-885c-ecd31377f4a8_AxisLogo400X4003.png",
              "title": "Get flat ₹150 OFF using Axis Bank Rewards Credit Cards",
              "description": "Flat ₹150 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Rewards Credit Cards (including all recently migrated ones)",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/9e11b331-7649-44de-a484-eb54bc4df00b_AxisLogo400X4003.png",
              "title": "Get flat ₹200 OFF using Axis Bank Select Credit Cards",
              "description": "Flat ₹200 OFF on orders above ₹1000",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Select Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹831 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS120",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1567725f-af88-42a4-8a7d-2db532b73f04_AxisLogo400X4003.png",
              "title": "Get Flat ₹120 OFF using Axis Bank MY ZONE Credit Cards",
              "description": "Flat ₹120 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank MY ZONE Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "HSBC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/a95eb3f5-251c-406b-80c8-da15ddb0d116_HSBCHexagon400x4001.png",
              "title": "Get 10% discount using select HSBC Credit Cards",
              "description": "Flat 10% discount up to ₹100 using select HSBC Credit Cards on orders above ₹999",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable from Wednesday to Sunday",
                  "Valid once per user during the offer period",
                  "Offer valid only on select HSBC Credit Cards",
                  "Not valid on HSBC Live+/ Cashback Credit Card variant starting with 431104",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹830 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "APAYFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/415f4674-6231-4e40-9378-1fbacb4f20cb_AmazonPayNewLogoJun23.png",
              "title": "Get up to ₹100 cashback using Amazon Pay Balance",
              "description": "Up to ₹100 cashback on Amazon Pay Balance transactions above ₹199",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the offer period",
                  "Valid on the net transaction amount of ₹199 & above using Amazon Pay Balance",
                  "Minimum assured cashback of ₹20 will be available in the form of a scratch card in your Amazon Pay account",
                  "Users are eligible for an assured cashback only once across Food & Instamart",
                  "Valid only for users who have linked their Amazon account and paid using Amazon Pay Balance",
                  "Not valid on payments via Amazon Pay UPI directly from the UPI section or Amazon Pay balance",
                  "The cashback will only be issued once the customer scratches the issued card by going to the Rewards page on Amazon Pay",
                  "Once the scratched card is scratched, cashback will be credited as Amazon Pay Balance within 24 hours",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹30 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISABOBDC",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f387cda5-008f-49c3-b443-6e7cc4873744_VisaBankofBarodaLogo.png",
              "title": "Get 20% discount using Bank of Baroda Visa Debit Cards",
              "description": "Maximum ₹130 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on Bank of Baroda Visa Debit Cards",
                  "Valid only on Monday, Tuesday, Wednesday & Thursday",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "INDUSINDDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/5721e0f9-0d11-4214-b70f-20a8b52e1ae5_IndusIndBankLogoBurgundyTwoLine02.png",
              "title": "Save ₹200 OFF using select IndusInd Bank Debit Cards",
              "description": "Maximum up to ₹200 OFF using IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards on orders above ₹600",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards variants",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹431 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS150",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/4cce62d6-9414-45f4-9d8e-82d689594b8a_AxisLogo400X4003.png",
              "title": "Get 25% OFF using Axis Bank Delight Debit Cards",
              "description": "Maximum up to ₹150 OFF on orders above ₹400",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable thrice per user per calendar month",
                  "Valid only on Axis Bank Delight Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹231 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MBKFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/31d31f7d-e9e2-40ea-b7c2-0f3cece34e78_MobiKwikFoodOffersLogoLatest2.png",
              "title": "Get up to ₹150 cashback using MobiKwik wallet",
              "description": "Assured ₹15 to ₹150 Instant Cashback via Scratch Card on MobiKwik wallet transactions above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per month",
                  "Assured cashback will be ₹15 per transaction",
                  "Valid on the net transaction amount of ₹249 & above using the MobiKwik wallet",
                  "Cashback can be claimed through a Scratch card on the MobiKwik app in the rewards section & the Scratch card will be valid for 7 days only",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/5/9d446beb-b2ce-480f-8b70-58b8e8038001_AUBank400X400Logo.png",
              "title": "Get 20% discount using AU Debit Cards",
              "description": "Maximum up to ₹111 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid only on AU Debit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "PNBCC125",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/e948424c-1683-492c-ad40-dab329505568_PNBFoodOffersLogo.png",
              "title": "Get 15% discount using Punjab National Bank Credit Cards",
              "description": "Maximum discount of ₹125 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Punjab National Bank Credit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZAGGCARD",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/18/361c4086-1746-439a-bd0a-75acbae97c28_ZaggCoinLogo.png",
              "title": "Get 40% discount using Zagg Credit Card",
              "description": "Maximum up to ₹100 OFF on orders above ₹200",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Zagg Credit Cards issued under BIN 356191906",
                  "Applicable once per user during the offer period",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹31 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUCC50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/d8ce833e-602e-4be8-bb61-c51f8dc115cf_AUBank400X400Logo.png",
              "title": "Get 5% discount using AU Credit Cards",
              "description": "Maximum discount of ₹50 on orders above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per month",
                  "Valid only on AU Credit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBICC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f294f5a3-a376-4f5b-87b5-58e9dbc4dbf3_IDBI400X4004.png",
              "title": "Get 15% discount using IDBI Bank Credit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IDBI Bank Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBIDC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ba5c2bab-955a-4ff6-8345-6ec6d96d6631_IDBI400X4004.png",
              "title": "Get 15% discount using select IDBI Bank Debit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on IDBI Bank Platinum & Signature variant Debit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZETCARD100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/b47eb00e-6232-40ab-8c68-24486989a87c_ZET400x400Logo.png",
              "title": "Get Flat ₹100 OFF using ZET Credit Card",
              "description": "Get ZET Credit Card on the Zet App to unlock this Offer, Flat ₹100 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on all ZET cards issued by SBM Bank, IOB, and DCB Bank",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARACC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/abe79014-b8e3-48fc-b05e-e05162ceddd9_CanaraBankVisaNewLogo.png",
              "title": "Get 15% discount using Canara Bank Visa Credit Cards",
              "description": "Maximum discount up to ₹100 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CBIDC75",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/14/4bd1e216-0f03-4326-bda0-fa7e8cb14713_CentralBankOfIndiaFoodOffersLogo.png",
              "title": "Get flat ₹75 discount using Central Bank of India Debit Cards",
              "description": "Flat ₹75 OFF on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid on all Central Bank of India Debit Cards",
                  "Applicable once per user per week",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 21, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 6 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARADC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/8e46ed72-e428-40f1-98e6-032505f8a22f_CanaraBankVisaNewLogo.png",
              "title": "Flat ₹100 OFF",
              "description": "Use Canara Bank Visa Debit Cards to get Flat ₹100 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "NOVIO100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ff4ecf82-7ac5-4b3a-870a-f4464f90a07e_NovioFoodOffersLogo.png",
              "title": "Get flat ₹100 discount using SBM Credilio Credit Card",
              "description": "FLAT ₹100 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Get your guaranteed SBM Credilio Credit Card on the Novio App",
                  "Applicable once per user during the offer period",
                  "Exclusive to SBM Credilio Credit Card holders",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        }
      ]
    },
    "tid": "88cc8a44-ea1a-4fb8-9a9f-20e77fc757a1",
    "sid": "p4p56099-037e-40d8-a215-e0604df50d69",
    "deviceId": "663cd9c7-0449-024f-940c-b517fba567ac",
    "csrfToken": "IzwxRju6nNXv-bKlcmCx3Uwxi_sTnjW1EN3f_WAs"
  },

  "581782": {
    "statusCode": 0,
    "data": {
      "cacheExpiryTime": 320,
      "pages": 2,
      "pageIndex": 0,
      "nextPageFetch": 0,
      "cards": [
        {
          "cardType": "couponApplyWidget",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "couponApplyWidget",
            "data": {
              "textPlaceHolder": "Enter Coupon Code",
              "buttonText": "Apply"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "AVAILABLE COUPONS"
            },
            "subtype": "couponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "UNAVAILABLE COUPONS"
            },
            "subtype": "unavailableCouponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT80",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.80 off",
              "description": "Use code FLAT80 & get flat ₹80 off on orders above ₹249.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to get a Flat ₹80 off"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT150",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs. 150 off",
              "description": "Use code FLAT150 & get flat ₹150 off orders above ₹599.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CELEBRATIONS",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.200 off",
              "description": "Use code CELEBRATION & get ₹200 off on orders above ₹799",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹630 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "SWIGGYIT",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get 60% off",
              "description": "Use code SWIGGYIT & get 60% off on orders above ₹179. Maximum discount: ₹110.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hr on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹10 more to get a discount upto ₹110"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MASTERCARDNEW50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/8/2ebec6c7-0843-4daf-8f21-931da1f17888_4.png",
              "title": "Get FLAT ₹50 cashback by tokenizing your Mastercard",
              "description": "Secure & pay using your Mastercard to get ₹50 cashback into your Swiggy Money wallet on transactions above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the campaign",
                  "Valid only on a minimum transaction value of ₹399",
                  "Cashback will only be processed to the users who have tokenized their Mastercard debit or credit card during the payment",
                  "Cashback will be credited to your Swiggy Money wallet in 15 days from the transaction date",
                  "Other T&Cs may apply",
                  "Offer valid till Apr 30, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 105 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXISREWARDS",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1de7c3ce-0a38-4705-885c-ecd31377f4a8_AxisLogo400X4003.png",
              "title": "Get flat ₹150 OFF using Axis Bank Rewards Credit Cards",
              "description": "Flat ₹150 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Rewards Credit Cards (including all recently migrated ones)",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/9e11b331-7649-44de-a484-eb54bc4df00b_AxisLogo400X4003.png",
              "title": "Get flat ₹200 OFF using Axis Bank Select Credit Cards",
              "description": "Flat ₹200 OFF on orders above ₹1000",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Select Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹831 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS120",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1567725f-af88-42a4-8a7d-2db532b73f04_AxisLogo400X4003.png",
              "title": "Get Flat ₹120 OFF using Axis Bank MY ZONE Credit Cards",
              "description": "Flat ₹120 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank MY ZONE Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "HSBC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/a95eb3f5-251c-406b-80c8-da15ddb0d116_HSBCHexagon400x4001.png",
              "title": "Get 10% discount using select HSBC Credit Cards",
              "description": "Flat 10% discount up to ₹100 using select HSBC Credit Cards on orders above ₹999",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable from Wednesday to Sunday",
                  "Valid once per user during the offer period",
                  "Offer valid only on select HSBC Credit Cards",
                  "Not valid on HSBC Live+/ Cashback Credit Card variant starting with 431104",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹830 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "APAYFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/415f4674-6231-4e40-9378-1fbacb4f20cb_AmazonPayNewLogoJun23.png",
              "title": "Get up to ₹100 cashback using Amazon Pay Balance",
              "description": "Up to ₹100 cashback on Amazon Pay Balance transactions above ₹199",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the offer period",
                  "Valid on the net transaction amount of ₹199 & above using Amazon Pay Balance",
                  "Minimum assured cashback of ₹20 will be available in the form of a scratch card in your Amazon Pay account",
                  "Users are eligible for an assured cashback only once across Food & Instamart",
                  "Valid only for users who have linked their Amazon account and paid using Amazon Pay Balance",
                  "Not valid on payments via Amazon Pay UPI directly from the UPI section or Amazon Pay balance",
                  "The cashback will only be issued once the customer scratches the issued card by going to the Rewards page on Amazon Pay",
                  "Once the scratched card is scratched, cashback will be credited as Amazon Pay Balance within 24 hours",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹30 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISABOBDC",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f387cda5-008f-49c3-b443-6e7cc4873744_VisaBankofBarodaLogo.png",
              "title": "Get 20% discount using Bank of Baroda Visa Debit Cards",
              "description": "Maximum ₹130 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on Bank of Baroda Visa Debit Cards",
                  "Valid only on Monday, Tuesday, Wednesday & Thursday",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "INDUSINDDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/5721e0f9-0d11-4214-b70f-20a8b52e1ae5_IndusIndBankLogoBurgundyTwoLine02.png",
              "title": "Save ₹200 OFF using select IndusInd Bank Debit Cards",
              "description": "Maximum up to ₹200 OFF using IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards on orders above ₹600",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards variants",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹431 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS150",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/4cce62d6-9414-45f4-9d8e-82d689594b8a_AxisLogo400X4003.png",
              "title": "Get 25% OFF using Axis Bank Delight Debit Cards",
              "description": "Maximum up to ₹150 OFF on orders above ₹400",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable thrice per user per calendar month",
                  "Valid only on Axis Bank Delight Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹231 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MBKFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/31d31f7d-e9e2-40ea-b7c2-0f3cece34e78_MobiKwikFoodOffersLogoLatest2.png",
              "title": "Get up to ₹150 cashback using MobiKwik wallet",
              "description": "Assured ₹15 to ₹150 Instant Cashback via Scratch Card on MobiKwik wallet transactions above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per month",
                  "Assured cashback will be ₹15 per transaction",
                  "Valid on the net transaction amount of ₹249 & above using the MobiKwik wallet",
                  "Cashback can be claimed through a Scratch card on the MobiKwik app in the rewards section & the Scratch card will be valid for 7 days only",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/5/9d446beb-b2ce-480f-8b70-58b8e8038001_AUBank400X400Logo.png",
              "title": "Get 20% discount using AU Debit Cards",
              "description": "Maximum up to ₹111 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid only on AU Debit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "PNBCC125",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/e948424c-1683-492c-ad40-dab329505568_PNBFoodOffersLogo.png",
              "title": "Get 15% discount using Punjab National Bank Credit Cards",
              "description": "Maximum discount of ₹125 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Punjab National Bank Credit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZAGGCARD",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/18/361c4086-1746-439a-bd0a-75acbae97c28_ZaggCoinLogo.png",
              "title": "Get 40% discount using Zagg Credit Card",
              "description": "Maximum up to ₹100 OFF on orders above ₹200",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Zagg Credit Cards issued under BIN 356191906",
                  "Applicable once per user during the offer period",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹31 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUCC50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/d8ce833e-602e-4be8-bb61-c51f8dc115cf_AUBank400X400Logo.png",
              "title": "Get 5% discount using AU Credit Cards",
              "description": "Maximum discount of ₹50 on orders above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per month",
                  "Valid only on AU Credit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBICC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f294f5a3-a376-4f5b-87b5-58e9dbc4dbf3_IDBI400X4004.png",
              "title": "Get 15% discount using IDBI Bank Credit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IDBI Bank Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBIDC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ba5c2bab-955a-4ff6-8345-6ec6d96d6631_IDBI400X4004.png",
              "title": "Get 15% discount using select IDBI Bank Debit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on IDBI Bank Platinum & Signature variant Debit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZETCARD100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/b47eb00e-6232-40ab-8c68-24486989a87c_ZET400x400Logo.png",
              "title": "Get Flat ₹100 OFF using ZET Credit Card",
              "description": "Get ZET Credit Card on the Zet App to unlock this Offer, Flat ₹100 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on all ZET cards issued by SBM Bank, IOB, and DCB Bank",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARACC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/abe79014-b8e3-48fc-b05e-e05162ceddd9_CanaraBankVisaNewLogo.png",
              "title": "Get 15% discount using Canara Bank Visa Credit Cards",
              "description": "Maximum discount up to ₹100 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CBIDC75",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/14/4bd1e216-0f03-4326-bda0-fa7e8cb14713_CentralBankOfIndiaFoodOffersLogo.png",
              "title": "Get flat ₹75 discount using Central Bank of India Debit Cards",
              "description": "Flat ₹75 OFF on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid on all Central Bank of India Debit Cards",
                  "Applicable once per user per week",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 21, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 6 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARADC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/8e46ed72-e428-40f1-98e6-032505f8a22f_CanaraBankVisaNewLogo.png",
              "title": "Flat ₹100 OFF",
              "description": "Use Canara Bank Visa Debit Cards to get Flat ₹100 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "NOVIO100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ff4ecf82-7ac5-4b3a-870a-f4464f90a07e_NovioFoodOffersLogo.png",
              "title": "Get flat ₹100 discount using SBM Credilio Credit Card",
              "description": "FLAT ₹100 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Get your guaranteed SBM Credilio Credit Card on the Novio App",
                  "Applicable once per user during the offer period",
                  "Exclusive to SBM Credilio Credit Card holders",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        }
      ]
    },
    "tid": "88cc8a44-ea1a-4fb8-9a9f-20e77fc757a1",
    "sid": "p4p56099-037e-40d8-a215-e0604df50d69",
    "deviceId": "663cd9c7-0449-024f-940c-b517fba567ac",
    "csrfToken": "PHz08kDNSsKj-J47AY4UkTllaxUbN0NHsTVwR2V4"
  },
  "585068": {
    "statusCode": 0,
    "data": {
      "cacheExpiryTime": 320,
      "pages": 2,
      "pageIndex": 0,
      "nextPageFetch": 0,
      "cards": [
        {
          "cardType": "couponApplyWidget",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "couponApplyWidget",
            "data": {
              "textPlaceHolder": "Enter Coupon Code",
              "buttonText": "Apply"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "AVAILABLE COUPONS"
            },
            "subtype": "couponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "UNAVAILABLE COUPONS"
            },
            "subtype": "unavailableCouponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT80",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.80 off",
              "description": "Use code FLAT80 & get flat ₹80 off on orders above ₹249.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to get a Flat ₹80 off"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT150",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs. 150 off",
              "description": "Use code FLAT150 & get flat ₹150 off orders above ₹599.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CELEBRATIONS",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.200 off",
              "description": "Use code CELEBRATION & get ₹200 off on orders above ₹799",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹630 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "SWIGGYIT",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get 60% off",
              "description": "Use code SWIGGYIT & get 60% off on orders above ₹179. Maximum discount: ₹110.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hr on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹10 more to get a discount upto ₹110"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MASTERCARDNEW50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/8/2ebec6c7-0843-4daf-8f21-931da1f17888_4.png",
              "title": "Get FLAT ₹50 cashback by tokenizing your Mastercard",
              "description": "Secure & pay using your Mastercard to get ₹50 cashback into your Swiggy Money wallet on transactions above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the campaign",
                  "Valid only on a minimum transaction value of ₹399",
                  "Cashback will only be processed to the users who have tokenized their Mastercard debit or credit card during the payment",
                  "Cashback will be credited to your Swiggy Money wallet in 15 days from the transaction date",
                  "Other T&Cs may apply",
                  "Offer valid till Apr 30, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 105 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXISREWARDS",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1de7c3ce-0a38-4705-885c-ecd31377f4a8_AxisLogo400X4003.png",
              "title": "Get flat ₹150 OFF using Axis Bank Rewards Credit Cards",
              "description": "Flat ₹150 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Rewards Credit Cards (including all recently migrated ones)",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/9e11b331-7649-44de-a484-eb54bc4df00b_AxisLogo400X4003.png",
              "title": "Get flat ₹200 OFF using Axis Bank Select Credit Cards",
              "description": "Flat ₹200 OFF on orders above ₹1000",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Select Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹831 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS120",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1567725f-af88-42a4-8a7d-2db532b73f04_AxisLogo400X4003.png",
              "title": "Get Flat ₹120 OFF using Axis Bank MY ZONE Credit Cards",
              "description": "Flat ₹120 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank MY ZONE Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "HSBC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/a95eb3f5-251c-406b-80c8-da15ddb0d116_HSBCHexagon400x4001.png",
              "title": "Get 10% discount using select HSBC Credit Cards",
              "description": "Flat 10% discount up to ₹100 using select HSBC Credit Cards on orders above ₹999",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable from Wednesday to Sunday",
                  "Valid once per user during the offer period",
                  "Offer valid only on select HSBC Credit Cards",
                  "Not valid on HSBC Live+/ Cashback Credit Card variant starting with 431104",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹830 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "APAYFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/415f4674-6231-4e40-9378-1fbacb4f20cb_AmazonPayNewLogoJun23.png",
              "title": "Get up to ₹100 cashback using Amazon Pay Balance",
              "description": "Up to ₹100 cashback on Amazon Pay Balance transactions above ₹199",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the offer period",
                  "Valid on the net transaction amount of ₹199 & above using Amazon Pay Balance",
                  "Minimum assured cashback of ₹20 will be available in the form of a scratch card in your Amazon Pay account",
                  "Users are eligible for an assured cashback only once across Food & Instamart",
                  "Valid only for users who have linked their Amazon account and paid using Amazon Pay Balance",
                  "Not valid on payments via Amazon Pay UPI directly from the UPI section or Amazon Pay balance",
                  "The cashback will only be issued once the customer scratches the issued card by going to the Rewards page on Amazon Pay",
                  "Once the scratched card is scratched, cashback will be credited as Amazon Pay Balance within 24 hours",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹30 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISABOBDC",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f387cda5-008f-49c3-b443-6e7cc4873744_VisaBankofBarodaLogo.png",
              "title": "Get 20% discount using Bank of Baroda Visa Debit Cards",
              "description": "Maximum ₹130 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on Bank of Baroda Visa Debit Cards",
                  "Valid only on Monday, Tuesday, Wednesday & Thursday",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "INDUSINDDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/5721e0f9-0d11-4214-b70f-20a8b52e1ae5_IndusIndBankLogoBurgundyTwoLine02.png",
              "title": "Save ₹200 OFF using select IndusInd Bank Debit Cards",
              "description": "Maximum up to ₹200 OFF using IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards on orders above ₹600",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards variants",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹431 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS150",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/4cce62d6-9414-45f4-9d8e-82d689594b8a_AxisLogo400X4003.png",
              "title": "Get 25% OFF using Axis Bank Delight Debit Cards",
              "description": "Maximum up to ₹150 OFF on orders above ₹400",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable thrice per user per calendar month",
                  "Valid only on Axis Bank Delight Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹231 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MBKFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/31d31f7d-e9e2-40ea-b7c2-0f3cece34e78_MobiKwikFoodOffersLogoLatest2.png",
              "title": "Get up to ₹150 cashback using MobiKwik wallet",
              "description": "Assured ₹15 to ₹150 Instant Cashback via Scratch Card on MobiKwik wallet transactions above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per month",
                  "Assured cashback will be ₹15 per transaction",
                  "Valid on the net transaction amount of ₹249 & above using the MobiKwik wallet",
                  "Cashback can be claimed through a Scratch card on the MobiKwik app in the rewards section & the Scratch card will be valid for 7 days only",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/5/9d446beb-b2ce-480f-8b70-58b8e8038001_AUBank400X400Logo.png",
              "title": "Get 20% discount using AU Debit Cards",
              "description": "Maximum up to ₹111 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid only on AU Debit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "PNBCC125",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/e948424c-1683-492c-ad40-dab329505568_PNBFoodOffersLogo.png",
              "title": "Get 15% discount using Punjab National Bank Credit Cards",
              "description": "Maximum discount of ₹125 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Punjab National Bank Credit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZAGGCARD",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/18/361c4086-1746-439a-bd0a-75acbae97c28_ZaggCoinLogo.png",
              "title": "Get 40% discount using Zagg Credit Card",
              "description": "Maximum up to ₹100 OFF on orders above ₹200",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Zagg Credit Cards issued under BIN 356191906",
                  "Applicable once per user during the offer period",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹31 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUCC50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/d8ce833e-602e-4be8-bb61-c51f8dc115cf_AUBank400X400Logo.png",
              "title": "Get 5% discount using AU Credit Cards",
              "description": "Maximum discount of ₹50 on orders above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per month",
                  "Valid only on AU Credit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBICC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f294f5a3-a376-4f5b-87b5-58e9dbc4dbf3_IDBI400X4004.png",
              "title": "Get 15% discount using IDBI Bank Credit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IDBI Bank Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBIDC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ba5c2bab-955a-4ff6-8345-6ec6d96d6631_IDBI400X4004.png",
              "title": "Get 15% discount using select IDBI Bank Debit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on IDBI Bank Platinum & Signature variant Debit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZETCARD100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/b47eb00e-6232-40ab-8c68-24486989a87c_ZET400x400Logo.png",
              "title": "Get Flat ₹100 OFF using ZET Credit Card",
              "description": "Get ZET Credit Card on the Zet App to unlock this Offer, Flat ₹100 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on all ZET cards issued by SBM Bank, IOB, and DCB Bank",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARACC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/abe79014-b8e3-48fc-b05e-e05162ceddd9_CanaraBankVisaNewLogo.png",
              "title": "Get 15% discount using Canara Bank Visa Credit Cards",
              "description": "Maximum discount up to ₹100 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CBIDC75",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/14/4bd1e216-0f03-4326-bda0-fa7e8cb14713_CentralBankOfIndiaFoodOffersLogo.png",
              "title": "Get flat ₹75 discount using Central Bank of India Debit Cards",
              "description": "Flat ₹75 OFF on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid on all Central Bank of India Debit Cards",
                  "Applicable once per user per week",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 21, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 6 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARADC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/8e46ed72-e428-40f1-98e6-032505f8a22f_CanaraBankVisaNewLogo.png",
              "title": "Flat ₹100 OFF",
              "description": "Use Canara Bank Visa Debit Cards to get Flat ₹100 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "NOVIO100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ff4ecf82-7ac5-4b3a-870a-f4464f90a07e_NovioFoodOffersLogo.png",
              "title": "Get flat ₹100 discount using SBM Credilio Credit Card",
              "description": "FLAT ₹100 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Get your guaranteed SBM Credilio Credit Card on the Novio App",
                  "Applicable once per user during the offer period",
                  "Exclusive to SBM Credilio Credit Card holders",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        }
      ]
    },
    "tid": "88cc8a44-ea1a-4fb8-9a9f-20e77fc757a1",
    "sid": "p4p56099-037e-40d8-a215-e0604df50d69",
    "deviceId": "663cd9c7-0449-024f-940c-b517fba567ac",
    "csrfToken": "mWefFZ378rIB-wbiKztc7ffYav9TV7jZE2l2930g"
  },
  "637339": {
    "statusCode": 0,
    "data": {
      "cacheExpiryTime": 320,
      "pages": 2,
      "pageIndex": 0,
      "nextPageFetch": 0,
      "cards": [
        {
          "cardType": "couponApplyWidget",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "couponApplyWidget",
            "data": {
              "textPlaceHolder": "Enter Coupon Code",
              "buttonText": "Apply"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "AVAILABLE COUPONS"
            },
            "subtype": "couponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "UNAVAILABLE COUPONS"
            },
            "subtype": "unavailableCouponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT80",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.80 off",
              "description": "Use code FLAT80 & get flat ₹80 off on orders above ₹249.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to get a Flat ₹80 off"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT150",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs. 150 off",
              "description": "Use code FLAT150 & get flat ₹150 off orders above ₹599.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CELEBRATIONS",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.200 off",
              "description": "Use code CELEBRATION & get ₹200 off on orders above ₹799",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹630 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "SWIGGYIT",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get 60% off",
              "description": "Use code SWIGGYIT & get 60% off on orders above ₹179. Maximum discount: ₹110.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hr on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹10 more to get a discount upto ₹110"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MASTERCARDNEW50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/8/2ebec6c7-0843-4daf-8f21-931da1f17888_4.png",
              "title": "Get FLAT ₹50 cashback by tokenizing your Mastercard",
              "description": "Secure & pay using your Mastercard to get ₹50 cashback into your Swiggy Money wallet on transactions above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the campaign",
                  "Valid only on a minimum transaction value of ₹399",
                  "Cashback will only be processed to the users who have tokenized their Mastercard debit or credit card during the payment",
                  "Cashback will be credited to your Swiggy Money wallet in 15 days from the transaction date",
                  "Other T&Cs may apply",
                  "Offer valid till Apr 30, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 105 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXISREWARDS",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1de7c3ce-0a38-4705-885c-ecd31377f4a8_AxisLogo400X4003.png",
              "title": "Get flat ₹150 OFF using Axis Bank Rewards Credit Cards",
              "description": "Flat ₹150 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Rewards Credit Cards (including all recently migrated ones)",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/9e11b331-7649-44de-a484-eb54bc4df00b_AxisLogo400X4003.png",
              "title": "Get flat ₹200 OFF using Axis Bank Select Credit Cards",
              "description": "Flat ₹200 OFF on orders above ₹1000",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Select Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹831 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS120",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1567725f-af88-42a4-8a7d-2db532b73f04_AxisLogo400X4003.png",
              "title": "Get Flat ₹120 OFF using Axis Bank MY ZONE Credit Cards",
              "description": "Flat ₹120 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank MY ZONE Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "HSBC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/a95eb3f5-251c-406b-80c8-da15ddb0d116_HSBCHexagon400x4001.png",
              "title": "Get 10% discount using select HSBC Credit Cards",
              "description": "Flat 10% discount up to ₹100 using select HSBC Credit Cards on orders above ₹999",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable from Wednesday to Sunday",
                  "Valid once per user during the offer period",
                  "Offer valid only on select HSBC Credit Cards",
                  "Not valid on HSBC Live+/ Cashback Credit Card variant starting with 431104",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹830 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "APAYFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/415f4674-6231-4e40-9378-1fbacb4f20cb_AmazonPayNewLogoJun23.png",
              "title": "Get up to ₹100 cashback using Amazon Pay Balance",
              "description": "Up to ₹100 cashback on Amazon Pay Balance transactions above ₹199",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the offer period",
                  "Valid on the net transaction amount of ₹199 & above using Amazon Pay Balance",
                  "Minimum assured cashback of ₹20 will be available in the form of a scratch card in your Amazon Pay account",
                  "Users are eligible for an assured cashback only once across Food & Instamart",
                  "Valid only for users who have linked their Amazon account and paid using Amazon Pay Balance",
                  "Not valid on payments via Amazon Pay UPI directly from the UPI section or Amazon Pay balance",
                  "The cashback will only be issued once the customer scratches the issued card by going to the Rewards page on Amazon Pay",
                  "Once the scratched card is scratched, cashback will be credited as Amazon Pay Balance within 24 hours",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹30 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISABOBDC",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f387cda5-008f-49c3-b443-6e7cc4873744_VisaBankofBarodaLogo.png",
              "title": "Get 20% discount using Bank of Baroda Visa Debit Cards",
              "description": "Maximum ₹130 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on Bank of Baroda Visa Debit Cards",
                  "Valid only on Monday, Tuesday, Wednesday & Thursday",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "INDUSINDDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/5721e0f9-0d11-4214-b70f-20a8b52e1ae5_IndusIndBankLogoBurgundyTwoLine02.png",
              "title": "Save ₹200 OFF using select IndusInd Bank Debit Cards",
              "description": "Maximum up to ₹200 OFF using IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards on orders above ₹600",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards variants",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹431 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS150",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/4cce62d6-9414-45f4-9d8e-82d689594b8a_AxisLogo400X4003.png",
              "title": "Get 25% OFF using Axis Bank Delight Debit Cards",
              "description": "Maximum up to ₹150 OFF on orders above ₹400",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable thrice per user per calendar month",
                  "Valid only on Axis Bank Delight Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹231 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MBKFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/31d31f7d-e9e2-40ea-b7c2-0f3cece34e78_MobiKwikFoodOffersLogoLatest2.png",
              "title": "Get up to ₹150 cashback using MobiKwik wallet",
              "description": "Assured ₹15 to ₹150 Instant Cashback via Scratch Card on MobiKwik wallet transactions above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per month",
                  "Assured cashback will be ₹15 per transaction",
                  "Valid on the net transaction amount of ₹249 & above using the MobiKwik wallet",
                  "Cashback can be claimed through a Scratch card on the MobiKwik app in the rewards section & the Scratch card will be valid for 7 days only",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/5/9d446beb-b2ce-480f-8b70-58b8e8038001_AUBank400X400Logo.png",
              "title": "Get 20% discount using AU Debit Cards",
              "description": "Maximum up to ₹111 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid only on AU Debit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "PNBCC125",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/e948424c-1683-492c-ad40-dab329505568_PNBFoodOffersLogo.png",
              "title": "Get 15% discount using Punjab National Bank Credit Cards",
              "description": "Maximum discount of ₹125 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Punjab National Bank Credit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZAGGCARD",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/18/361c4086-1746-439a-bd0a-75acbae97c28_ZaggCoinLogo.png",
              "title": "Get 40% discount using Zagg Credit Card",
              "description": "Maximum up to ₹100 OFF on orders above ₹200",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Zagg Credit Cards issued under BIN 356191906",
                  "Applicable once per user during the offer period",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹31 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUCC50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/d8ce833e-602e-4be8-bb61-c51f8dc115cf_AUBank400X400Logo.png",
              "title": "Get 5% discount using AU Credit Cards",
              "description": "Maximum discount of ₹50 on orders above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per month",
                  "Valid only on AU Credit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBICC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f294f5a3-a376-4f5b-87b5-58e9dbc4dbf3_IDBI400X4004.png",
              "title": "Get 15% discount using IDBI Bank Credit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IDBI Bank Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBIDC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ba5c2bab-955a-4ff6-8345-6ec6d96d6631_IDBI400X4004.png",
              "title": "Get 15% discount using select IDBI Bank Debit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on IDBI Bank Platinum & Signature variant Debit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZETCARD100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/b47eb00e-6232-40ab-8c68-24486989a87c_ZET400x400Logo.png",
              "title": "Get Flat ₹100 OFF using ZET Credit Card",
              "description": "Get ZET Credit Card on the Zet App to unlock this Offer, Flat ₹100 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on all ZET cards issued by SBM Bank, IOB, and DCB Bank",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARACC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/abe79014-b8e3-48fc-b05e-e05162ceddd9_CanaraBankVisaNewLogo.png",
              "title": "Get 15% discount using Canara Bank Visa Credit Cards",
              "description": "Maximum discount up to ₹100 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CBIDC75",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/14/4bd1e216-0f03-4326-bda0-fa7e8cb14713_CentralBankOfIndiaFoodOffersLogo.png",
              "title": "Get flat ₹75 discount using Central Bank of India Debit Cards",
              "description": "Flat ₹75 OFF on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid on all Central Bank of India Debit Cards",
                  "Applicable once per user per week",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 21, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 6 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARADC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/8e46ed72-e428-40f1-98e6-032505f8a22f_CanaraBankVisaNewLogo.png",
              "title": "Flat ₹100 OFF",
              "description": "Use Canara Bank Visa Debit Cards to get Flat ₹100 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "NOVIO100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ff4ecf82-7ac5-4b3a-870a-f4464f90a07e_NovioFoodOffersLogo.png",
              "title": "Get flat ₹100 discount using SBM Credilio Credit Card",
              "description": "FLAT ₹100 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Get your guaranteed SBM Credilio Credit Card on the Novio App",
                  "Applicable once per user during the offer period",
                  "Exclusive to SBM Credilio Credit Card holders",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        }
      ]
    },
    "tid": "88cc8a44-ea1a-4fb8-9a9f-20e77fc757a1",
    "sid": "p4p56099-037e-40d8-a215-e0604df50d69",
    "deviceId": "663cd9c7-0449-024f-940c-b517fba567ac",
    "csrfToken": "q0kgf0qQUTMm-EMl1edDf0-KPbaMlPdxTtX68vr0"
  },
  "253997": {
    "statusCode": 0,
    "data": {
      "cacheExpiryTime": 320,
      "pages": 2,
      "pageIndex": 0,
      "nextPageFetch": 0,
      "cards": [
        {
          "cardType": "couponApplyWidget",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "couponApplyWidget",
            "data": {
              "textPlaceHolder": "Enter Coupon Code",
              "buttonText": "Apply"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "AVAILABLE COUPONS"
            },
            "subtype": "couponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "UNAVAILABLE COUPONS"
            },
            "subtype": "unavailableCouponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT80",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.80 off",
              "description": "Use code FLAT80 & get flat ₹80 off on orders above ₹249.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to get a Flat ₹80 off"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT150",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs. 150 off",
              "description": "Use code FLAT150 & get flat ₹150 off orders above ₹599.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CELEBRATIONS",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.200 off",
              "description": "Use code CELEBRATION & get ₹200 off on orders above ₹799",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹630 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "SWIGGYIT",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get 60% off",
              "description": "Use code SWIGGYIT & get 60% off on orders above ₹179. Maximum discount: ₹110.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hr on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹10 more to get a discount upto ₹110"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MASTERCARDNEW50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/8/2ebec6c7-0843-4daf-8f21-931da1f17888_4.png",
              "title": "Get FLAT ₹50 cashback by tokenizing your Mastercard",
              "description": "Secure & pay using your Mastercard to get ₹50 cashback into your Swiggy Money wallet on transactions above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the campaign",
                  "Valid only on a minimum transaction value of ₹399",
                  "Cashback will only be processed to the users who have tokenized their Mastercard debit or credit card during the payment",
                  "Cashback will be credited to your Swiggy Money wallet in 15 days from the transaction date",
                  "Other T&Cs may apply",
                  "Offer valid till Apr 30, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 105 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXISREWARDS",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1de7c3ce-0a38-4705-885c-ecd31377f4a8_AxisLogo400X4003.png",
              "title": "Get flat ₹150 OFF using Axis Bank Rewards Credit Cards",
              "description": "Flat ₹150 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Rewards Credit Cards (including all recently migrated ones)",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/9e11b331-7649-44de-a484-eb54bc4df00b_AxisLogo400X4003.png",
              "title": "Get flat ₹200 OFF using Axis Bank Select Credit Cards",
              "description": "Flat ₹200 OFF on orders above ₹1000",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Select Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹831 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS120",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1567725f-af88-42a4-8a7d-2db532b73f04_AxisLogo400X4003.png",
              "title": "Get Flat ₹120 OFF using Axis Bank MY ZONE Credit Cards",
              "description": "Flat ₹120 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank MY ZONE Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "HSBC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/a95eb3f5-251c-406b-80c8-da15ddb0d116_HSBCHexagon400x4001.png",
              "title": "Get 10% discount using select HSBC Credit Cards",
              "description": "Flat 10% discount up to ₹100 using select HSBC Credit Cards on orders above ₹999",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable from Wednesday to Sunday",
                  "Valid once per user during the offer period",
                  "Offer valid only on select HSBC Credit Cards",
                  "Not valid on HSBC Live+/ Cashback Credit Card variant starting with 431104",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹830 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "APAYFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/415f4674-6231-4e40-9378-1fbacb4f20cb_AmazonPayNewLogoJun23.png",
              "title": "Get up to ₹100 cashback using Amazon Pay Balance",
              "description": "Up to ₹100 cashback on Amazon Pay Balance transactions above ₹199",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the offer period",
                  "Valid on the net transaction amount of ₹199 & above using Amazon Pay Balance",
                  "Minimum assured cashback of ₹20 will be available in the form of a scratch card in your Amazon Pay account",
                  "Users are eligible for an assured cashback only once across Food & Instamart",
                  "Valid only for users who have linked their Amazon account and paid using Amazon Pay Balance",
                  "Not valid on payments via Amazon Pay UPI directly from the UPI section or Amazon Pay balance",
                  "The cashback will only be issued once the customer scratches the issued card by going to the Rewards page on Amazon Pay",
                  "Once the scratched card is scratched, cashback will be credited as Amazon Pay Balance within 24 hours",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹30 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISABOBDC",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f387cda5-008f-49c3-b443-6e7cc4873744_VisaBankofBarodaLogo.png",
              "title": "Get 20% discount using Bank of Baroda Visa Debit Cards",
              "description": "Maximum ₹130 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on Bank of Baroda Visa Debit Cards",
                  "Valid only on Monday, Tuesday, Wednesday & Thursday",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "INDUSINDDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/5721e0f9-0d11-4214-b70f-20a8b52e1ae5_IndusIndBankLogoBurgundyTwoLine02.png",
              "title": "Save ₹200 OFF using select IndusInd Bank Debit Cards",
              "description": "Maximum up to ₹200 OFF using IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards on orders above ₹600",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards variants",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹431 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS150",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/4cce62d6-9414-45f4-9d8e-82d689594b8a_AxisLogo400X4003.png",
              "title": "Get 25% OFF using Axis Bank Delight Debit Cards",
              "description": "Maximum up to ₹150 OFF on orders above ₹400",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable thrice per user per calendar month",
                  "Valid only on Axis Bank Delight Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹231 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MBKFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/31d31f7d-e9e2-40ea-b7c2-0f3cece34e78_MobiKwikFoodOffersLogoLatest2.png",
              "title": "Get up to ₹150 cashback using MobiKwik wallet",
              "description": "Assured ₹15 to ₹150 Instant Cashback via Scratch Card on MobiKwik wallet transactions above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per month",
                  "Assured cashback will be ₹15 per transaction",
                  "Valid on the net transaction amount of ₹249 & above using the MobiKwik wallet",
                  "Cashback can be claimed through a Scratch card on the MobiKwik app in the rewards section & the Scratch card will be valid for 7 days only",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/5/9d446beb-b2ce-480f-8b70-58b8e8038001_AUBank400X400Logo.png",
              "title": "Get 20% discount using AU Debit Cards",
              "description": "Maximum up to ₹111 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid only on AU Debit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "PNBCC125",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/e948424c-1683-492c-ad40-dab329505568_PNBFoodOffersLogo.png",
              "title": "Get 15% discount using Punjab National Bank Credit Cards",
              "description": "Maximum discount of ₹125 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Punjab National Bank Credit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZAGGCARD",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/18/361c4086-1746-439a-bd0a-75acbae97c28_ZaggCoinLogo.png",
              "title": "Get 40% discount using Zagg Credit Card",
              "description": "Maximum up to ₹100 OFF on orders above ₹200",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Zagg Credit Cards issued under BIN 356191906",
                  "Applicable once per user during the offer period",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹31 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUCC50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/d8ce833e-602e-4be8-bb61-c51f8dc115cf_AUBank400X400Logo.png",
              "title": "Get 5% discount using AU Credit Cards",
              "description": "Maximum discount of ₹50 on orders above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per month",
                  "Valid only on AU Credit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBICC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f294f5a3-a376-4f5b-87b5-58e9dbc4dbf3_IDBI400X4004.png",
              "title": "Get 15% discount using IDBI Bank Credit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IDBI Bank Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBIDC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ba5c2bab-955a-4ff6-8345-6ec6d96d6631_IDBI400X4004.png",
              "title": "Get 15% discount using select IDBI Bank Debit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on IDBI Bank Platinum & Signature variant Debit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZETCARD100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/b47eb00e-6232-40ab-8c68-24486989a87c_ZET400x400Logo.png",
              "title": "Get Flat ₹100 OFF using ZET Credit Card",
              "description": "Get ZET Credit Card on the Zet App to unlock this Offer, Flat ₹100 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on all ZET cards issued by SBM Bank, IOB, and DCB Bank",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARACC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/abe79014-b8e3-48fc-b05e-e05162ceddd9_CanaraBankVisaNewLogo.png",
              "title": "Get 15% discount using Canara Bank Visa Credit Cards",
              "description": "Maximum discount up to ₹100 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CBIDC75",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/14/4bd1e216-0f03-4326-bda0-fa7e8cb14713_CentralBankOfIndiaFoodOffersLogo.png",
              "title": "Get flat ₹75 discount using Central Bank of India Debit Cards",
              "description": "Flat ₹75 OFF on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid on all Central Bank of India Debit Cards",
                  "Applicable once per user per week",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 21, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 6 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARADC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/8e46ed72-e428-40f1-98e6-032505f8a22f_CanaraBankVisaNewLogo.png",
              "title": "Flat ₹100 OFF",
              "description": "Use Canara Bank Visa Debit Cards to get Flat ₹100 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "NOVIO100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ff4ecf82-7ac5-4b3a-870a-f4464f90a07e_NovioFoodOffersLogo.png",
              "title": "Get flat ₹100 discount using SBM Credilio Credit Card",
              "description": "FLAT ₹100 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Get your guaranteed SBM Credilio Credit Card on the Novio App",
                  "Applicable once per user during the offer period",
                  "Exclusive to SBM Credilio Credit Card holders",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        }
      ]
    },
    "tid": "88cc8a44-ea1a-4fb8-9a9f-20e77fc757a1",
    "sid": "p4p56099-037e-40d8-a215-e0604df50d69",
    "deviceId": "663cd9c7-0449-024f-940c-b517fba567ac",
    "csrfToken": "JuBQjDzFVVNI-zfGHHTzFlNKEDcxdrDZn1ZKGZsc"
  },

  "501801": {
    "statusCode": 0,
    "data": {
      "cacheExpiryTime": 320,
      "pages": 2,
      "pageIndex": 0,
      "nextPageFetch": 0,
      "cards": [
        {
          "cardType": "couponApplyWidget",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "couponApplyWidget",
            "data": {
              "textPlaceHolder": "Enter Coupon Code",
              "buttonText": "Apply"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "AVAILABLE COUPONS"
            },
            "subtype": "couponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "UNAVAILABLE COUPONS"
            },
            "subtype": "unavailableCouponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT80",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.80 off",
              "description": "Use code FLAT80 & get flat ₹80 off on orders above ₹249.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to get a Flat ₹80 off"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT150",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs. 150 off",
              "description": "Use code FLAT150 & get flat ₹150 off orders above ₹599.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CELEBRATIONS",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.200 off",
              "description": "Use code CELEBRATION & get ₹200 off on orders above ₹799",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹630 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "SWIGGYIT",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get 60% off",
              "description": "Use code SWIGGYIT & get 60% off on orders above ₹179. Maximum discount: ₹110.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hr on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹10 more to get a discount upto ₹110"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MASTERCARDNEW50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/8/2ebec6c7-0843-4daf-8f21-931da1f17888_4.png",
              "title": "Get FLAT ₹50 cashback by tokenizing your Mastercard",
              "description": "Secure & pay using your Mastercard to get ₹50 cashback into your Swiggy Money wallet on transactions above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the campaign",
                  "Valid only on a minimum transaction value of ₹399",
                  "Cashback will only be processed to the users who have tokenized their Mastercard debit or credit card during the payment",
                  "Cashback will be credited to your Swiggy Money wallet in 15 days from the transaction date",
                  "Other T&Cs may apply",
                  "Offer valid till Apr 30, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 105 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXISREWARDS",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1de7c3ce-0a38-4705-885c-ecd31377f4a8_AxisLogo400X4003.png",
              "title": "Get flat ₹150 OFF using Axis Bank Rewards Credit Cards",
              "description": "Flat ₹150 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Rewards Credit Cards (including all recently migrated ones)",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/9e11b331-7649-44de-a484-eb54bc4df00b_AxisLogo400X4003.png",
              "title": "Get flat ₹200 OFF using Axis Bank Select Credit Cards",
              "description": "Flat ₹200 OFF on orders above ₹1000",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Select Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹831 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS120",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1567725f-af88-42a4-8a7d-2db532b73f04_AxisLogo400X4003.png",
              "title": "Get Flat ₹120 OFF using Axis Bank MY ZONE Credit Cards",
              "description": "Flat ₹120 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank MY ZONE Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "HSBC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/a95eb3f5-251c-406b-80c8-da15ddb0d116_HSBCHexagon400x4001.png",
              "title": "Get 10% discount using select HSBC Credit Cards",
              "description": "Flat 10% discount up to ₹100 using select HSBC Credit Cards on orders above ₹999",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable from Wednesday to Sunday",
                  "Valid once per user during the offer period",
                  "Offer valid only on select HSBC Credit Cards",
                  "Not valid on HSBC Live+/ Cashback Credit Card variant starting with 431104",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹830 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "APAYFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/415f4674-6231-4e40-9378-1fbacb4f20cb_AmazonPayNewLogoJun23.png",
              "title": "Get up to ₹100 cashback using Amazon Pay Balance",
              "description": "Up to ₹100 cashback on Amazon Pay Balance transactions above ₹199",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the offer period",
                  "Valid on the net transaction amount of ₹199 & above using Amazon Pay Balance",
                  "Minimum assured cashback of ₹20 will be available in the form of a scratch card in your Amazon Pay account",
                  "Users are eligible for an assured cashback only once across Food & Instamart",
                  "Valid only for users who have linked their Amazon account and paid using Amazon Pay Balance",
                  "Not valid on payments via Amazon Pay UPI directly from the UPI section or Amazon Pay balance",
                  "The cashback will only be issued once the customer scratches the issued card by going to the Rewards page on Amazon Pay",
                  "Once the scratched card is scratched, cashback will be credited as Amazon Pay Balance within 24 hours",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹30 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISABOBDC",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f387cda5-008f-49c3-b443-6e7cc4873744_VisaBankofBarodaLogo.png",
              "title": "Get 20% discount using Bank of Baroda Visa Debit Cards",
              "description": "Maximum ₹130 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on Bank of Baroda Visa Debit Cards",
                  "Valid only on Monday, Tuesday, Wednesday & Thursday",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "INDUSINDDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/5721e0f9-0d11-4214-b70f-20a8b52e1ae5_IndusIndBankLogoBurgundyTwoLine02.png",
              "title": "Save ₹200 OFF using select IndusInd Bank Debit Cards",
              "description": "Maximum up to ₹200 OFF using IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards on orders above ₹600",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards variants",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹431 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS150",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/4cce62d6-9414-45f4-9d8e-82d689594b8a_AxisLogo400X4003.png",
              "title": "Get 25% OFF using Axis Bank Delight Debit Cards",
              "description": "Maximum up to ₹150 OFF on orders above ₹400",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable thrice per user per calendar month",
                  "Valid only on Axis Bank Delight Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹231 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MBKFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/31d31f7d-e9e2-40ea-b7c2-0f3cece34e78_MobiKwikFoodOffersLogoLatest2.png",
              "title": "Get up to ₹150 cashback using MobiKwik wallet",
              "description": "Assured ₹15 to ₹150 Instant Cashback via Scratch Card on MobiKwik wallet transactions above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per month",
                  "Assured cashback will be ₹15 per transaction",
                  "Valid on the net transaction amount of ₹249 & above using the MobiKwik wallet",
                  "Cashback can be claimed through a Scratch card on the MobiKwik app in the rewards section & the Scratch card will be valid for 7 days only",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/5/9d446beb-b2ce-480f-8b70-58b8e8038001_AUBank400X400Logo.png",
              "title": "Get 20% discount using AU Debit Cards",
              "description": "Maximum up to ₹111 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid only on AU Debit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "PNBCC125",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/e948424c-1683-492c-ad40-dab329505568_PNBFoodOffersLogo.png",
              "title": "Get 15% discount using Punjab National Bank Credit Cards",
              "description": "Maximum discount of ₹125 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Punjab National Bank Credit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZAGGCARD",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/18/361c4086-1746-439a-bd0a-75acbae97c28_ZaggCoinLogo.png",
              "title": "Get 40% discount using Zagg Credit Card",
              "description": "Maximum up to ₹100 OFF on orders above ₹200",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Zagg Credit Cards issued under BIN 356191906",
                  "Applicable once per user during the offer period",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹31 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUCC50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/d8ce833e-602e-4be8-bb61-c51f8dc115cf_AUBank400X400Logo.png",
              "title": "Get 5% discount using AU Credit Cards",
              "description": "Maximum discount of ₹50 on orders above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per month",
                  "Valid only on AU Credit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBICC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f294f5a3-a376-4f5b-87b5-58e9dbc4dbf3_IDBI400X4004.png",
              "title": "Get 15% discount using IDBI Bank Credit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IDBI Bank Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBIDC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ba5c2bab-955a-4ff6-8345-6ec6d96d6631_IDBI400X4004.png",
              "title": "Get 15% discount using select IDBI Bank Debit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on IDBI Bank Platinum & Signature variant Debit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZETCARD100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/b47eb00e-6232-40ab-8c68-24486989a87c_ZET400x400Logo.png",
              "title": "Get Flat ₹100 OFF using ZET Credit Card",
              "description": "Get ZET Credit Card on the Zet App to unlock this Offer, Flat ₹100 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on all ZET cards issued by SBM Bank, IOB, and DCB Bank",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARACC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/abe79014-b8e3-48fc-b05e-e05162ceddd9_CanaraBankVisaNewLogo.png",
              "title": "Get 15% discount using Canara Bank Visa Credit Cards",
              "description": "Maximum discount up to ₹100 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CBIDC75",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/14/4bd1e216-0f03-4326-bda0-fa7e8cb14713_CentralBankOfIndiaFoodOffersLogo.png",
              "title": "Get flat ₹75 discount using Central Bank of India Debit Cards",
              "description": "Flat ₹75 OFF on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid on all Central Bank of India Debit Cards",
                  "Applicable once per user per week",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 21, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 6 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARADC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/8e46ed72-e428-40f1-98e6-032505f8a22f_CanaraBankVisaNewLogo.png",
              "title": "Flat ₹100 OFF",
              "description": "Use Canara Bank Visa Debit Cards to get Flat ₹100 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "NOVIO100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ff4ecf82-7ac5-4b3a-870a-f4464f90a07e_NovioFoodOffersLogo.png",
              "title": "Get flat ₹100 discount using SBM Credilio Credit Card",
              "description": "FLAT ₹100 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Get your guaranteed SBM Credilio Credit Card on the Novio App",
                  "Applicable once per user during the offer period",
                  "Exclusive to SBM Credilio Credit Card holders",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        }
      ]
    },
    "tid": "88cc8a44-ea1a-4fb8-9a9f-20e77fc757a1",
    "sid": "p4p56099-037e-40d8-a215-e0604df50d69",
    "deviceId": "663cd9c7-0449-024f-940c-b517fba567ac",
    "csrfToken": "FGYTbuV5gZTx-bIWVCLonZe-5BZEqmah0EKO3emA"
  },
  "111098": {
    "statusCode": 0,
    "data": {
      "cacheExpiryTime": 320,
      "pages": 2,
      "pageIndex": 0,
      "nextPageFetch": 0,
      "cards": [
        {
          "cardType": "couponApplyWidget",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "couponApplyWidget",
            "data": {
              "textPlaceHolder": "Enter Coupon Code",
              "buttonText": "Apply"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "AVAILABLE COUPONS"
            },
            "subtype": "couponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "UNAVAILABLE COUPONS"
            },
            "subtype": "unavailableCouponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT80",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.80 off",
              "description": "Use code FLAT80 & get flat ₹80 off on orders above ₹249.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to get a Flat ₹80 off"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT150",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs. 150 off",
              "description": "Use code FLAT150 & get flat ₹150 off orders above ₹599.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CELEBRATIONS",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.200 off",
              "description": "Use code CELEBRATION & get ₹200 off on orders above ₹799",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹630 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "SWIGGYIT",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get 60% off",
              "description": "Use code SWIGGYIT & get 60% off on orders above ₹179. Maximum discount: ₹110.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hr on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹10 more to get a discount upto ₹110"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MASTERCARDNEW50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/8/2ebec6c7-0843-4daf-8f21-931da1f17888_4.png",
              "title": "Get FLAT ₹50 cashback by tokenizing your Mastercard",
              "description": "Secure & pay using your Mastercard to get ₹50 cashback into your Swiggy Money wallet on transactions above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the campaign",
                  "Valid only on a minimum transaction value of ₹399",
                  "Cashback will only be processed to the users who have tokenized their Mastercard debit or credit card during the payment",
                  "Cashback will be credited to your Swiggy Money wallet in 15 days from the transaction date",
                  "Other T&Cs may apply",
                  "Offer valid till Apr 30, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 105 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXISREWARDS",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1de7c3ce-0a38-4705-885c-ecd31377f4a8_AxisLogo400X4003.png",
              "title": "Get flat ₹150 OFF using Axis Bank Rewards Credit Cards",
              "description": "Flat ₹150 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Rewards Credit Cards (including all recently migrated ones)",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/9e11b331-7649-44de-a484-eb54bc4df00b_AxisLogo400X4003.png",
              "title": "Get flat ₹200 OFF using Axis Bank Select Credit Cards",
              "description": "Flat ₹200 OFF on orders above ₹1000",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Select Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹831 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS120",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1567725f-af88-42a4-8a7d-2db532b73f04_AxisLogo400X4003.png",
              "title": "Get Flat ₹120 OFF using Axis Bank MY ZONE Credit Cards",
              "description": "Flat ₹120 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank MY ZONE Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "HSBC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/a95eb3f5-251c-406b-80c8-da15ddb0d116_HSBCHexagon400x4001.png",
              "title": "Get 10% discount using select HSBC Credit Cards",
              "description": "Flat 10% discount up to ₹100 using select HSBC Credit Cards on orders above ₹999",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable from Wednesday to Sunday",
                  "Valid once per user during the offer period",
                  "Offer valid only on select HSBC Credit Cards",
                  "Not valid on HSBC Live+/ Cashback Credit Card variant starting with 431104",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹830 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "APAYFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/415f4674-6231-4e40-9378-1fbacb4f20cb_AmazonPayNewLogoJun23.png",
              "title": "Get up to ₹100 cashback using Amazon Pay Balance",
              "description": "Up to ₹100 cashback on Amazon Pay Balance transactions above ₹199",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the offer period",
                  "Valid on the net transaction amount of ₹199 & above using Amazon Pay Balance",
                  "Minimum assured cashback of ₹20 will be available in the form of a scratch card in your Amazon Pay account",
                  "Users are eligible for an assured cashback only once across Food & Instamart",
                  "Valid only for users who have linked their Amazon account and paid using Amazon Pay Balance",
                  "Not valid on payments via Amazon Pay UPI directly from the UPI section or Amazon Pay balance",
                  "The cashback will only be issued once the customer scratches the issued card by going to the Rewards page on Amazon Pay",
                  "Once the scratched card is scratched, cashback will be credited as Amazon Pay Balance within 24 hours",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹30 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISABOBDC",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f387cda5-008f-49c3-b443-6e7cc4873744_VisaBankofBarodaLogo.png",
              "title": "Get 20% discount using Bank of Baroda Visa Debit Cards",
              "description": "Maximum ₹130 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on Bank of Baroda Visa Debit Cards",
                  "Valid only on Monday, Tuesday, Wednesday & Thursday",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "INDUSINDDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/5721e0f9-0d11-4214-b70f-20a8b52e1ae5_IndusIndBankLogoBurgundyTwoLine02.png",
              "title": "Save ₹200 OFF using select IndusInd Bank Debit Cards",
              "description": "Maximum up to ₹200 OFF using IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards on orders above ₹600",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards variants",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹431 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS150",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/4cce62d6-9414-45f4-9d8e-82d689594b8a_AxisLogo400X4003.png",
              "title": "Get 25% OFF using Axis Bank Delight Debit Cards",
              "description": "Maximum up to ₹150 OFF on orders above ₹400",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable thrice per user per calendar month",
                  "Valid only on Axis Bank Delight Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹231 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MBKFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/31d31f7d-e9e2-40ea-b7c2-0f3cece34e78_MobiKwikFoodOffersLogoLatest2.png",
              "title": "Get up to ₹150 cashback using MobiKwik wallet",
              "description": "Assured ₹15 to ₹150 Instant Cashback via Scratch Card on MobiKwik wallet transactions above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per month",
                  "Assured cashback will be ₹15 per transaction",
                  "Valid on the net transaction amount of ₹249 & above using the MobiKwik wallet",
                  "Cashback can be claimed through a Scratch card on the MobiKwik app in the rewards section & the Scratch card will be valid for 7 days only",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/5/9d446beb-b2ce-480f-8b70-58b8e8038001_AUBank400X400Logo.png",
              "title": "Get 20% discount using AU Debit Cards",
              "description": "Maximum up to ₹111 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid only on AU Debit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "PNBCC125",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/e948424c-1683-492c-ad40-dab329505568_PNBFoodOffersLogo.png",
              "title": "Get 15% discount using Punjab National Bank Credit Cards",
              "description": "Maximum discount of ₹125 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Punjab National Bank Credit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZAGGCARD",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/18/361c4086-1746-439a-bd0a-75acbae97c28_ZaggCoinLogo.png",
              "title": "Get 40% discount using Zagg Credit Card",
              "description": "Maximum up to ₹100 OFF on orders above ₹200",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Zagg Credit Cards issued under BIN 356191906",
                  "Applicable once per user during the offer period",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹31 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUCC50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/d8ce833e-602e-4be8-bb61-c51f8dc115cf_AUBank400X400Logo.png",
              "title": "Get 5% discount using AU Credit Cards",
              "description": "Maximum discount of ₹50 on orders above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per month",
                  "Valid only on AU Credit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBICC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f294f5a3-a376-4f5b-87b5-58e9dbc4dbf3_IDBI400X4004.png",
              "title": "Get 15% discount using IDBI Bank Credit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IDBI Bank Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBIDC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ba5c2bab-955a-4ff6-8345-6ec6d96d6631_IDBI400X4004.png",
              "title": "Get 15% discount using select IDBI Bank Debit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on IDBI Bank Platinum & Signature variant Debit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZETCARD100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/b47eb00e-6232-40ab-8c68-24486989a87c_ZET400x400Logo.png",
              "title": "Get Flat ₹100 OFF using ZET Credit Card",
              "description": "Get ZET Credit Card on the Zet App to unlock this Offer, Flat ₹100 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on all ZET cards issued by SBM Bank, IOB, and DCB Bank",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARACC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/abe79014-b8e3-48fc-b05e-e05162ceddd9_CanaraBankVisaNewLogo.png",
              "title": "Get 15% discount using Canara Bank Visa Credit Cards",
              "description": "Maximum discount up to ₹100 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CBIDC75",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/14/4bd1e216-0f03-4326-bda0-fa7e8cb14713_CentralBankOfIndiaFoodOffersLogo.png",
              "title": "Get flat ₹75 discount using Central Bank of India Debit Cards",
              "description": "Flat ₹75 OFF on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid on all Central Bank of India Debit Cards",
                  "Applicable once per user per week",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 21, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 6 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARADC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/8e46ed72-e428-40f1-98e6-032505f8a22f_CanaraBankVisaNewLogo.png",
              "title": "Flat ₹100 OFF",
              "description": "Use Canara Bank Visa Debit Cards to get Flat ₹100 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "NOVIO100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ff4ecf82-7ac5-4b3a-870a-f4464f90a07e_NovioFoodOffersLogo.png",
              "title": "Get flat ₹100 discount using SBM Credilio Credit Card",
              "description": "FLAT ₹100 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Get your guaranteed SBM Credilio Credit Card on the Novio App",
                  "Applicable once per user during the offer period",
                  "Exclusive to SBM Credilio Credit Card holders",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        }
      ]
    },
    "tid": "88cc8a44-ea1a-4fb8-9a9f-20e77fc757a1",
    "sid": "p4p56099-037e-40d8-a215-e0604df50d69",
    "deviceId": "663cd9c7-0449-024f-940c-b517fba567ac",
    "csrfToken": "7Uc5MRge0jrl-7gfowdJdb_8WOK-bmN1dSoQTq90"
  },
  "376280": {
    "statusCode": 0,
    "data": {
      "cacheExpiryTime": 320,
      "pages": 2,
      "pageIndex": 0,
      "nextPageFetch": 0,
      "cards": [
        {
          "cardType": "couponApplyWidget",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "couponApplyWidget",
            "data": {
              "textPlaceHolder": "Enter Coupon Code",
              "buttonText": "Apply"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "AVAILABLE COUPONS"
            },
            "subtype": "couponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "UNAVAILABLE COUPONS"
            },
            "subtype": "unavailableCouponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT80",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.80 off",
              "description": "Use code FLAT80 & get flat ₹80 off on orders above ₹249.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to get a Flat ₹80 off"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT150",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs. 150 off",
              "description": "Use code FLAT150 & get flat ₹150 off orders above ₹599.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CELEBRATIONS",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.200 off",
              "description": "Use code CELEBRATION & get ₹200 off on orders above ₹799",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹630 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "SWIGGYIT",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get 60% off",
              "description": "Use code SWIGGYIT & get 60% off on orders above ₹179. Maximum discount: ₹110.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hr on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹10 more to get a discount upto ₹110"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MASTERCARDNEW50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/8/2ebec6c7-0843-4daf-8f21-931da1f17888_4.png",
              "title": "Get FLAT ₹50 cashback by tokenizing your Mastercard",
              "description": "Secure & pay using your Mastercard to get ₹50 cashback into your Swiggy Money wallet on transactions above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the campaign",
                  "Valid only on a minimum transaction value of ₹399",
                  "Cashback will only be processed to the users who have tokenized their Mastercard debit or credit card during the payment",
                  "Cashback will be credited to your Swiggy Money wallet in 15 days from the transaction date",
                  "Other T&Cs may apply",
                  "Offer valid till Apr 30, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 105 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXISREWARDS",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1de7c3ce-0a38-4705-885c-ecd31377f4a8_AxisLogo400X4003.png",
              "title": "Get flat ₹150 OFF using Axis Bank Rewards Credit Cards",
              "description": "Flat ₹150 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Rewards Credit Cards (including all recently migrated ones)",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/9e11b331-7649-44de-a484-eb54bc4df00b_AxisLogo400X4003.png",
              "title": "Get flat ₹200 OFF using Axis Bank Select Credit Cards",
              "description": "Flat ₹200 OFF on orders above ₹1000",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Select Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹831 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS120",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1567725f-af88-42a4-8a7d-2db532b73f04_AxisLogo400X4003.png",
              "title": "Get Flat ₹120 OFF using Axis Bank MY ZONE Credit Cards",
              "description": "Flat ₹120 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank MY ZONE Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "HSBC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/a95eb3f5-251c-406b-80c8-da15ddb0d116_HSBCHexagon400x4001.png",
              "title": "Get 10% discount using select HSBC Credit Cards",
              "description": "Flat 10% discount up to ₹100 using select HSBC Credit Cards on orders above ₹999",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable from Wednesday to Sunday",
                  "Valid once per user during the offer period",
                  "Offer valid only on select HSBC Credit Cards",
                  "Not valid on HSBC Live+/ Cashback Credit Card variant starting with 431104",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹830 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "APAYFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/415f4674-6231-4e40-9378-1fbacb4f20cb_AmazonPayNewLogoJun23.png",
              "title": "Get up to ₹100 cashback using Amazon Pay Balance",
              "description": "Up to ₹100 cashback on Amazon Pay Balance transactions above ₹199",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the offer period",
                  "Valid on the net transaction amount of ₹199 & above using Amazon Pay Balance",
                  "Minimum assured cashback of ₹20 will be available in the form of a scratch card in your Amazon Pay account",
                  "Users are eligible for an assured cashback only once across Food & Instamart",
                  "Valid only for users who have linked their Amazon account and paid using Amazon Pay Balance",
                  "Not valid on payments via Amazon Pay UPI directly from the UPI section or Amazon Pay balance",
                  "The cashback will only be issued once the customer scratches the issued card by going to the Rewards page on Amazon Pay",
                  "Once the scratched card is scratched, cashback will be credited as Amazon Pay Balance within 24 hours",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹30 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISABOBDC",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f387cda5-008f-49c3-b443-6e7cc4873744_VisaBankofBarodaLogo.png",
              "title": "Get 20% discount using Bank of Baroda Visa Debit Cards",
              "description": "Maximum ₹130 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on Bank of Baroda Visa Debit Cards",
                  "Valid only on Monday, Tuesday, Wednesday & Thursday",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "INDUSINDDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/5721e0f9-0d11-4214-b70f-20a8b52e1ae5_IndusIndBankLogoBurgundyTwoLine02.png",
              "title": "Save ₹200 OFF using select IndusInd Bank Debit Cards",
              "description": "Maximum up to ₹200 OFF using IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards on orders above ₹600",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards variants",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹431 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS150",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/4cce62d6-9414-45f4-9d8e-82d689594b8a_AxisLogo400X4003.png",
              "title": "Get 25% OFF using Axis Bank Delight Debit Cards",
              "description": "Maximum up to ₹150 OFF on orders above ₹400",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable thrice per user per calendar month",
                  "Valid only on Axis Bank Delight Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹231 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MBKFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/31d31f7d-e9e2-40ea-b7c2-0f3cece34e78_MobiKwikFoodOffersLogoLatest2.png",
              "title": "Get up to ₹150 cashback using MobiKwik wallet",
              "description": "Assured ₹15 to ₹150 Instant Cashback via Scratch Card on MobiKwik wallet transactions above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per month",
                  "Assured cashback will be ₹15 per transaction",
                  "Valid on the net transaction amount of ₹249 & above using the MobiKwik wallet",
                  "Cashback can be claimed through a Scratch card on the MobiKwik app in the rewards section & the Scratch card will be valid for 7 days only",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/5/9d446beb-b2ce-480f-8b70-58b8e8038001_AUBank400X400Logo.png",
              "title": "Get 20% discount using AU Debit Cards",
              "description": "Maximum up to ₹111 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid only on AU Debit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "PNBCC125",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/e948424c-1683-492c-ad40-dab329505568_PNBFoodOffersLogo.png",
              "title": "Get 15% discount using Punjab National Bank Credit Cards",
              "description": "Maximum discount of ₹125 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Punjab National Bank Credit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZAGGCARD",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/18/361c4086-1746-439a-bd0a-75acbae97c28_ZaggCoinLogo.png",
              "title": "Get 40% discount using Zagg Credit Card",
              "description": "Maximum up to ₹100 OFF on orders above ₹200",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Zagg Credit Cards issued under BIN 356191906",
                  "Applicable once per user during the offer period",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹31 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUCC50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/d8ce833e-602e-4be8-bb61-c51f8dc115cf_AUBank400X400Logo.png",
              "title": "Get 5% discount using AU Credit Cards",
              "description": "Maximum discount of ₹50 on orders above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per month",
                  "Valid only on AU Credit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBICC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f294f5a3-a376-4f5b-87b5-58e9dbc4dbf3_IDBI400X4004.png",
              "title": "Get 15% discount using IDBI Bank Credit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IDBI Bank Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBIDC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ba5c2bab-955a-4ff6-8345-6ec6d96d6631_IDBI400X4004.png",
              "title": "Get 15% discount using select IDBI Bank Debit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on IDBI Bank Platinum & Signature variant Debit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZETCARD100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/b47eb00e-6232-40ab-8c68-24486989a87c_ZET400x400Logo.png",
              "title": "Get Flat ₹100 OFF using ZET Credit Card",
              "description": "Get ZET Credit Card on the Zet App to unlock this Offer, Flat ₹100 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on all ZET cards issued by SBM Bank, IOB, and DCB Bank",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARACC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/abe79014-b8e3-48fc-b05e-e05162ceddd9_CanaraBankVisaNewLogo.png",
              "title": "Get 15% discount using Canara Bank Visa Credit Cards",
              "description": "Maximum discount up to ₹100 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CBIDC75",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/14/4bd1e216-0f03-4326-bda0-fa7e8cb14713_CentralBankOfIndiaFoodOffersLogo.png",
              "title": "Get flat ₹75 discount using Central Bank of India Debit Cards",
              "description": "Flat ₹75 OFF on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid on all Central Bank of India Debit Cards",
                  "Applicable once per user per week",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 21, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 6 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARADC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/8e46ed72-e428-40f1-98e6-032505f8a22f_CanaraBankVisaNewLogo.png",
              "title": "Flat ₹100 OFF",
              "description": "Use Canara Bank Visa Debit Cards to get Flat ₹100 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "NOVIO100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ff4ecf82-7ac5-4b3a-870a-f4464f90a07e_NovioFoodOffersLogo.png",
              "title": "Get flat ₹100 discount using SBM Credilio Credit Card",
              "description": "FLAT ₹100 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Get your guaranteed SBM Credilio Credit Card on the Novio App",
                  "Applicable once per user during the offer period",
                  "Exclusive to SBM Credilio Credit Card holders",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        }
      ]
    },
    "tid": "88cc8a44-ea1a-4fb8-9a9f-20e77fc757a1",
    "sid": "p4p56099-037e-40d8-a215-e0604df50d69",
    "deviceId": "663cd9c7-0449-024f-940c-b517fba567ac",
    "csrfToken": "KFE8khMPkfLg-PFrlT7242R_3wETsRnG6m5MX_k0"
  },

  "119238": {
    "statusCode": 0,
    "data": {
      "cacheExpiryTime": 320,
      "pages": 2,
      "pageIndex": 0,
      "nextPageFetch": 0,
      "cards": [
        {
          "cardType": "couponApplyWidget",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "couponApplyWidget",
            "data": {
              "textPlaceHolder": "Enter Coupon Code",
              "buttonText": "Apply"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "AVAILABLE COUPONS"
            },
            "subtype": "couponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "UNAVAILABLE COUPONS"
            },
            "subtype": "unavailableCouponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT80",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.80 off",
              "description": "Use code FLAT80 & get flat ₹80 off on orders above ₹249.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to get a Flat ₹80 off"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT150",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs. 150 off",
              "description": "Use code FLAT150 & get flat ₹150 off orders above ₹599.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CELEBRATIONS",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.200 off",
              "description": "Use code CELEBRATION & get ₹200 off on orders above ₹799",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹630 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "SWIGGYIT",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get 60% off",
              "description": "Use code SWIGGYIT & get 60% off on orders above ₹179. Maximum discount: ₹110.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hr on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹10 more to get a discount upto ₹110"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MASTERCARDNEW50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/8/2ebec6c7-0843-4daf-8f21-931da1f17888_4.png",
              "title": "Get FLAT ₹50 cashback by tokenizing your Mastercard",
              "description": "Secure & pay using your Mastercard to get ₹50 cashback into your Swiggy Money wallet on transactions above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the campaign",
                  "Valid only on a minimum transaction value of ₹399",
                  "Cashback will only be processed to the users who have tokenized their Mastercard debit or credit card during the payment",
                  "Cashback will be credited to your Swiggy Money wallet in 15 days from the transaction date",
                  "Other T&Cs may apply",
                  "Offer valid till Apr 30, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 105 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXISREWARDS",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1de7c3ce-0a38-4705-885c-ecd31377f4a8_AxisLogo400X4003.png",
              "title": "Get flat ₹150 OFF using Axis Bank Rewards Credit Cards",
              "description": "Flat ₹150 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Rewards Credit Cards (including all recently migrated ones)",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/9e11b331-7649-44de-a484-eb54bc4df00b_AxisLogo400X4003.png",
              "title": "Get flat ₹200 OFF using Axis Bank Select Credit Cards",
              "description": "Flat ₹200 OFF on orders above ₹1000",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Select Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹831 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS120",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1567725f-af88-42a4-8a7d-2db532b73f04_AxisLogo400X4003.png",
              "title": "Get Flat ₹120 OFF using Axis Bank MY ZONE Credit Cards",
              "description": "Flat ₹120 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank MY ZONE Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "HSBC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/a95eb3f5-251c-406b-80c8-da15ddb0d116_HSBCHexagon400x4001.png",
              "title": "Get 10% discount using select HSBC Credit Cards",
              "description": "Flat 10% discount up to ₹100 using select HSBC Credit Cards on orders above ₹999",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable from Wednesday to Sunday",
                  "Valid once per user during the offer period",
                  "Offer valid only on select HSBC Credit Cards",
                  "Not valid on HSBC Live+/ Cashback Credit Card variant starting with 431104",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹830 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "APAYFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/415f4674-6231-4e40-9378-1fbacb4f20cb_AmazonPayNewLogoJun23.png",
              "title": "Get up to ₹100 cashback using Amazon Pay Balance",
              "description": "Up to ₹100 cashback on Amazon Pay Balance transactions above ₹199",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the offer period",
                  "Valid on the net transaction amount of ₹199 & above using Amazon Pay Balance",
                  "Minimum assured cashback of ₹20 will be available in the form of a scratch card in your Amazon Pay account",
                  "Users are eligible for an assured cashback only once across Food & Instamart",
                  "Valid only for users who have linked their Amazon account and paid using Amazon Pay Balance",
                  "Not valid on payments via Amazon Pay UPI directly from the UPI section or Amazon Pay balance",
                  "The cashback will only be issued once the customer scratches the issued card by going to the Rewards page on Amazon Pay",
                  "Once the scratched card is scratched, cashback will be credited as Amazon Pay Balance within 24 hours",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹30 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISABOBDC",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f387cda5-008f-49c3-b443-6e7cc4873744_VisaBankofBarodaLogo.png",
              "title": "Get 20% discount using Bank of Baroda Visa Debit Cards",
              "description": "Maximum ₹130 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on Bank of Baroda Visa Debit Cards",
                  "Valid only on Monday, Tuesday, Wednesday & Thursday",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "INDUSINDDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/5721e0f9-0d11-4214-b70f-20a8b52e1ae5_IndusIndBankLogoBurgundyTwoLine02.png",
              "title": "Save ₹200 OFF using select IndusInd Bank Debit Cards",
              "description": "Maximum up to ₹200 OFF using IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards on orders above ₹600",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards variants",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹431 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS150",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/4cce62d6-9414-45f4-9d8e-82d689594b8a_AxisLogo400X4003.png",
              "title": "Get 25% OFF using Axis Bank Delight Debit Cards",
              "description": "Maximum up to ₹150 OFF on orders above ₹400",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable thrice per user per calendar month",
                  "Valid only on Axis Bank Delight Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹231 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MBKFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/31d31f7d-e9e2-40ea-b7c2-0f3cece34e78_MobiKwikFoodOffersLogoLatest2.png",
              "title": "Get up to ₹150 cashback using MobiKwik wallet",
              "description": "Assured ₹15 to ₹150 Instant Cashback via Scratch Card on MobiKwik wallet transactions above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per month",
                  "Assured cashback will be ₹15 per transaction",
                  "Valid on the net transaction amount of ₹249 & above using the MobiKwik wallet",
                  "Cashback can be claimed through a Scratch card on the MobiKwik app in the rewards section & the Scratch card will be valid for 7 days only",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/5/9d446beb-b2ce-480f-8b70-58b8e8038001_AUBank400X400Logo.png",
              "title": "Get 20% discount using AU Debit Cards",
              "description": "Maximum up to ₹111 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid only on AU Debit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "PNBCC125",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/e948424c-1683-492c-ad40-dab329505568_PNBFoodOffersLogo.png",
              "title": "Get 15% discount using Punjab National Bank Credit Cards",
              "description": "Maximum discount of ₹125 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Punjab National Bank Credit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZAGGCARD",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/18/361c4086-1746-439a-bd0a-75acbae97c28_ZaggCoinLogo.png",
              "title": "Get 40% discount using Zagg Credit Card",
              "description": "Maximum up to ₹100 OFF on orders above ₹200",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Zagg Credit Cards issued under BIN 356191906",
                  "Applicable once per user during the offer period",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹31 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUCC50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/d8ce833e-602e-4be8-bb61-c51f8dc115cf_AUBank400X400Logo.png",
              "title": "Get 5% discount using AU Credit Cards",
              "description": "Maximum discount of ₹50 on orders above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per month",
                  "Valid only on AU Credit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBICC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f294f5a3-a376-4f5b-87b5-58e9dbc4dbf3_IDBI400X4004.png",
              "title": "Get 15% discount using IDBI Bank Credit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IDBI Bank Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBIDC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ba5c2bab-955a-4ff6-8345-6ec6d96d6631_IDBI400X4004.png",
              "title": "Get 15% discount using select IDBI Bank Debit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on IDBI Bank Platinum & Signature variant Debit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZETCARD100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/b47eb00e-6232-40ab-8c68-24486989a87c_ZET400x400Logo.png",
              "title": "Get Flat ₹100 OFF using ZET Credit Card",
              "description": "Get ZET Credit Card on the Zet App to unlock this Offer, Flat ₹100 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on all ZET cards issued by SBM Bank, IOB, and DCB Bank",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARACC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/abe79014-b8e3-48fc-b05e-e05162ceddd9_CanaraBankVisaNewLogo.png",
              "title": "Get 15% discount using Canara Bank Visa Credit Cards",
              "description": "Maximum discount up to ₹100 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CBIDC75",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/14/4bd1e216-0f03-4326-bda0-fa7e8cb14713_CentralBankOfIndiaFoodOffersLogo.png",
              "title": "Get flat ₹75 discount using Central Bank of India Debit Cards",
              "description": "Flat ₹75 OFF on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid on all Central Bank of India Debit Cards",
                  "Applicable once per user per week",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 21, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 6 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARADC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/8e46ed72-e428-40f1-98e6-032505f8a22f_CanaraBankVisaNewLogo.png",
              "title": "Flat ₹100 OFF",
              "description": "Use Canara Bank Visa Debit Cards to get Flat ₹100 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "NOVIO100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ff4ecf82-7ac5-4b3a-870a-f4464f90a07e_NovioFoodOffersLogo.png",
              "title": "Get flat ₹100 discount using SBM Credilio Credit Card",
              "description": "FLAT ₹100 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Get your guaranteed SBM Credilio Credit Card on the Novio App",
                  "Applicable once per user during the offer period",
                  "Exclusive to SBM Credilio Credit Card holders",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        }
      ]
    },
    "tid": "88cc8a44-ea1a-4fb8-9a9f-20e77fc757a1",
    "sid": "p4p56099-037e-40d8-a215-e0604df50d69",
    "deviceId": "663cd9c7-0449-024f-940c-b517fba567ac",
    "csrfToken": "OgCHO3U5DLp2-WFVJeK4PiBZ6L_HcqVFP45UNI1o"
  },
  "117679": {
    "statusCode": 0,
    "data": {
      "cacheExpiryTime": 320,
      "pages": 2,
      "pageIndex": 0,
      "nextPageFetch": 0,
      "cards": [
        {
          "cardType": "couponApplyWidget",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "couponApplyWidget",
            "data": {
              "textPlaceHolder": "Enter Coupon Code",
              "buttonText": "Apply"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "AVAILABLE COUPONS"
            },
            "subtype": "couponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "messageCard",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "messageCard",
            "data": {
              "message": "UNAVAILABLE COUPONS"
            },
            "subtype": "unavailableCouponsHeader",
            "sticky": 0
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT80",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.80 off",
              "description": "Use code FLAT80 & get flat ₹80 off on orders above ₹249.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to get a Flat ₹80 off"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "FLAT150",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs. 150 off",
              "description": "Use code FLAT150 & get flat ₹150 off orders above ₹599.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CELEBRATIONS",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get Flat Rs.200 off",
              "description": "Use code CELEBRATION & get ₹200 off on orders above ₹799",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hrs on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹630 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "SWIGGYIT",
              "logo": "rng/md/ads/production/jcuiipzv1wspesayzyok",
              "title": "Get 60% off",
              "description": "Use code SWIGGYIT & get 60% off on orders above ₹179. Maximum discount: ₹110.",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Offer is valid only on select restaurants",
                  "Coupon code can be applied only once in 2 hr on this restaurant",
                  "Other T&Cs may apply",
                  "Offer valid till Dec 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹10 more to get a discount upto ₹110"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 350 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MASTERCARDNEW50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/8/2ebec6c7-0843-4daf-8f21-931da1f17888_4.png",
              "title": "Get FLAT ₹50 cashback by tokenizing your Mastercard",
              "description": "Secure & pay using your Mastercard to get ₹50 cashback into your Swiggy Money wallet on transactions above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the campaign",
                  "Valid only on a minimum transaction value of ₹399",
                  "Cashback will only be processed to the users who have tokenized their Mastercard debit or credit card during the payment",
                  "Cashback will be credited to your Swiggy Money wallet in 15 days from the transaction date",
                  "Other T&Cs may apply",
                  "Offer valid till Apr 30, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 105 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXISREWARDS",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1de7c3ce-0a38-4705-885c-ecd31377f4a8_AxisLogo400X4003.png",
              "title": "Get flat ₹150 OFF using Axis Bank Rewards Credit Cards",
              "description": "Flat ₹150 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Rewards Credit Cards (including all recently migrated ones)",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/9e11b331-7649-44de-a484-eb54bc4df00b_AxisLogo400X4003.png",
              "title": "Get flat ₹200 OFF using Axis Bank Select Credit Cards",
              "description": "Flat ₹200 OFF on orders above ₹1000",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank Select Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹831 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS120",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/1567725f-af88-42a4-8a7d-2db532b73f04_AxisLogo400X4003.png",
              "title": "Get Flat ₹120 OFF using Axis Bank MY ZONE Credit Cards",
              "description": "Flat ₹120 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per calendar month",
                  "Valid only on Axis Bank MY ZONE Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "HSBC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/a95eb3f5-251c-406b-80c8-da15ddb0d116_HSBCHexagon400x4001.png",
              "title": "Get 10% discount using select HSBC Credit Cards",
              "description": "Flat 10% discount up to ₹100 using select HSBC Credit Cards on orders above ₹999",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable from Wednesday to Sunday",
                  "Valid once per user during the offer period",
                  "Offer valid only on select HSBC Credit Cards",
                  "Not valid on HSBC Live+/ Cashback Credit Card variant starting with 431104",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹830 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "APAYFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/415f4674-6231-4e40-9378-1fbacb4f20cb_AmazonPayNewLogoJun23.png",
              "title": "Get up to ₹100 cashback using Amazon Pay Balance",
              "description": "Up to ₹100 cashback on Amazon Pay Balance transactions above ₹199",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user during the offer period",
                  "Valid on the net transaction amount of ₹199 & above using Amazon Pay Balance",
                  "Minimum assured cashback of ₹20 will be available in the form of a scratch card in your Amazon Pay account",
                  "Users are eligible for an assured cashback only once across Food & Instamart",
                  "Valid only for users who have linked their Amazon account and paid using Amazon Pay Balance",
                  "Not valid on payments via Amazon Pay UPI directly from the UPI section or Amazon Pay balance",
                  "The cashback will only be issued once the customer scratches the issued card by going to the Rewards page on Amazon Pay",
                  "Once the scratched card is scratched, cashback will be credited as Amazon Pay Balance within 24 hours",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹30 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISABOBDC",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f387cda5-008f-49c3-b443-6e7cc4873744_VisaBankofBarodaLogo.png",
              "title": "Get 20% discount using Bank of Baroda Visa Debit Cards",
              "description": "Maximum ₹130 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on Bank of Baroda Visa Debit Cards",
                  "Valid only on Monday, Tuesday, Wednesday & Thursday",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "INDUSINDDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/5721e0f9-0d11-4214-b70f-20a8b52e1ae5_IndusIndBankLogoBurgundyTwoLine02.png",
              "title": "Save ₹200 OFF using select IndusInd Bank Debit Cards",
              "description": "Maximum up to ₹200 OFF using IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards on orders above ₹600",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IndusInd Bank Grande, Pioneer, Solitaire & Pioneer Private Debit Cards variants",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹431 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AXIS150",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/4cce62d6-9414-45f4-9d8e-82d689594b8a_AxisLogo400X4003.png",
              "title": "Get 25% OFF using Axis Bank Delight Debit Cards",
              "description": "Maximum up to ₹150 OFF on orders above ₹400",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable thrice per user per calendar month",
                  "Valid only on Axis Bank Delight Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹231 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "MBKFEST",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/31d31f7d-e9e2-40ea-b7c2-0f3cece34e78_MobiKwikFoodOffersLogoLatest2.png",
              "title": "Get up to ₹150 cashback using MobiKwik wallet",
              "description": "Assured ₹15 to ₹150 Instant Cashback via Scratch Card on MobiKwik wallet transactions above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable twice per user per month",
                  "Assured cashback will be ₹15 per transaction",
                  "Valid on the net transaction amount of ₹249 & above using the MobiKwik wallet",
                  "Cashback can be claimed through a Scratch card on the MobiKwik app in the rewards section & the Scratch card will be valid for 7 days only",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUDC20",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/5/9d446beb-b2ce-480f-8b70-58b8e8038001_AUBank400X400Logo.png",
              "title": "Get 20% discount using AU Debit Cards",
              "description": "Maximum up to ₹111 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid only on AU Debit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "PNBCC125",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/e948424c-1683-492c-ad40-dab329505568_PNBFoodOffersLogo.png",
              "title": "Get 15% discount using Punjab National Bank Credit Cards",
              "description": "Maximum discount of ₹125 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Punjab National Bank Credit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZAGGCARD",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/18/361c4086-1746-439a-bd0a-75acbae97c28_ZaggCoinLogo.png",
              "title": "Get 40% discount using Zagg Credit Card",
              "description": "Maximum up to ₹100 OFF on orders above ₹200",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on Zagg Credit Cards issued under BIN 356191906",
                  "Applicable once per user during the offer period",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹31 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "AUCC50",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/2/d8ce833e-602e-4be8-bb61-c51f8dc115cf_AUBank400X400Logo.png",
              "title": "Get 5% discount using AU Credit Cards",
              "description": "Maximum discount of ₹50 on orders above ₹249",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per month",
                  "Valid only on AU Credit Cards",
                  "Other T&C may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹80 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBICC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/f294f5a3-a376-4f5b-87b5-58e9dbc4dbf3_IDBI400X4004.png",
              "title": "Get 15% discount using IDBI Bank Credit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on IDBI Bank Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "IDBIDC200",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ba5c2bab-955a-4ff6-8345-6ec6d96d6631_IDBI400X4004.png",
              "title": "Get 15% discount using select IDBI Bank Debit Cards",
              "description": "Maximum discount up to ₹200 on orders above ₹599",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid only on IDBI Bank Platinum & Signature variant Debit Cards",
                  "Applicable once per user per calendar month",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹430 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "ZETCARD100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/b47eb00e-6232-40ab-8c68-24486989a87c_ZET400x400Logo.png",
              "title": "Get Flat ₹100 OFF using ZET Credit Card",
              "description": "Get ZET Credit Card on the Zet App to unlock this Offer, Flat ₹100 OFF on orders above ₹500",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Offer valid on all ZET cards issued by SBM Bank, IOB, and DCB Bank",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹331 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARACC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/abe79014-b8e3-48fc-b05e-e05162ceddd9_CanaraBankVisaNewLogo.png",
              "title": "Get 15% discount using Canara Bank Visa Credit Cards",
              "description": "Maximum discount up to ₹100 on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Credit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "CBIDC75",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/14/4bd1e216-0f03-4326-bda0-fa7e8cb14713_CentralBankOfIndiaFoodOffersLogo.png",
              "title": "Get flat ₹75 discount using Central Bank of India Debit Cards",
              "description": "Flat ₹75 OFF on orders above ₹399",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Valid on all Central Bank of India Debit Cards",
                  "Applicable once per user per week",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 21, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹230 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 6 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "VISACANARADC100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/8e46ed72-e428-40f1-98e6-032505f8a22f_CanaraBankVisaNewLogo.png",
              "title": "Flat ₹100 OFF",
              "description": "Use Canara Bank Visa Debit Cards to get Flat ₹100 OFF on orders above ₹299",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Applicable once per user per calendar month",
                  "Valid only on Canara Bank Visa Debit Cards",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹130 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        },
        {
          "cardType": "unavailableCouponCardV2",
          "layoutAlignmentType": "VERTICAL",
          "data": {
            "type": "unavailableCouponCardV2",
            "data": {
              "couponCode": "NOVIO100",
              "logo": "MARKETING_BANNERS/IMAGES/OFFERS/2026/1/1/ff4ecf82-7ac5-4b3a-870a-f4464f90a07e_NovioFoodOffersLogo.png",
              "title": "Get flat ₹100 discount using SBM Credilio Credit Card",
              "description": "FLAT ₹100 OFF on orders above ₹499",
              "tnc": {
                "title": "Terms and Conditions",
                "bulletTexts": [
                  "Get your guaranteed SBM Credilio Credit Card on the Novio App",
                  "Applicable once per user during the offer period",
                  "Exclusive to SBM Credilio Credit Card holders",
                  "Other T&Cs may apply",
                  "Offer valid till Jan 31, 2026 11:59 PM"
                ],
                "closeButtonText": "Okay! GOT IT"
              },
              "isApplicable": false,
              "couponPreValidationStatus": {
                "status": "NOT_APPLICABLE_CART_MIN",
                "message": "Add ₹330 more to avail this offer"
              },
              "offerTag": "",
              "offerTagColor": "#E46D47",
              "validTill": "Expires in 16 days"
            },
            "subtype": "basic"
          }
        }
      ]
    },
    "tid": "88cc8a44-ea1a-4fb8-9a9f-20e77fc757a1",
    "sid": "p4p56099-037e-40d8-a215-e0604df50d69",
    "deviceId": "663cd9c7-0449-024f-940c-b517fba567ac",
    "csrfToken": "hCF4EMYJcXXt-r74292pT-IR2z2WfSUMOXZJIWEc"
  }
}
